(async function (global) {
  'use strict';
  const uuid = /^(?!00000000-0000-0000-0000-000000000000)[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const unique = values => [...new Set((Array.isArray(values) ? values : []).filter(v => typeof v === 'string' && uuid.test(v)).map(v => v.toLowerCase()))];
  function normalize(value) {
    value = value && typeof value === 'object' ? value : {};
    const seen = new Set();
    return {
      schemaVersion: 1, revision: Number.isSafeInteger(value.revision) && value.revision >= 0 ? value.revision : 0,
      vehicles: (Array.isArray(value.vehicles) ? value.vehicles : []).filter(v => v && uuid.test(v.id) && uuid.test(v.groupId)
        && typeof v.label === 'string' && v.label.trim() && !seen.has(v.id) && seen.add(v.id)).slice(0, 20)
        .map(v => ({ id: v.id.toLowerCase(), groupId: v.groupId.toLowerCase(), label: v.label.trim().slice(0, 80) })),
      selectedGroupIds: unique(value.selectedGroupIds).slice(0, 5), includeUniversal: value.includeUniversal !== false
    };
  }
  function mergeVehicles(account, guest) {
    const result = [...account];
    for (const car of guest) if (!result.some(v => v.groupId === car.groupId) && result.length < 20) result.push(car);
    return result;
  }
  function searchPath(root, state, query = '', extra = {}) {
    const p = new URLSearchParams({ q: query, type: 'product', ...extra });
    if (state.selectedGroupIds.length) p.set('groups', state.selectedGroupIds.join(','));
    if (!state.includeUniversal) p.set('universal', 'false');
    return root + 'search?' + p;
  }
  function collectionPath(href, origin, labels, includeUniversal, universalLabel, groupIds) {
    const url = new URL(href, origin);
    if (url.origin !== origin || !url.pathname.includes('/collections/')) return null;
    const key = 'filter.p.m.pim.vehicle_fitment';
    url.searchParams.delete(key); url.searchParams.delete('page');
    labels.forEach(label => url.searchParams.append(key, label));
    if (includeUniversal && universalLabel) url.searchParams.append(key, universalLabel);
    if (groupIds) url.searchParams.set('groups', groupIds.join(','));
    return url.pathname + url.search + url.hash;
  }
  function vehicleLink(href, origin, state, groups = []) {
    const url = new URL(href, origin);
    // Carry the browsing selection through editorial pages and the home/logo link
    // too. These URL values work even when preference storage is unavailable.
    const storefrontPage = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?(?:\/?$|\/search\/?$|\/(?:products|collections|pages|blogs)(?:\/|$))/i;
    if (href.startsWith('#') || url.origin !== origin || !storefrontPage.test(url.pathname)) return href;
    if (!url.searchParams.has('groups')) {
      const landing = groups.find(g => g.collectionHandle && url.pathname.endsWith('/collections/' + g.collectionHandle));
      const nativeLabels = url.searchParams.getAll('filter.p.m.pim.vehicle_fitment');
      const ids = nativeLabels.length ? groups.filter(g => nativeLabels.includes(g.label)).map(g => g.id)
        : landing ? [landing.id] : state.selectedGroupIds;
      url.searchParams.set('groups', ids.join(','));
    }
    if (!url.searchParams.has('universal')) url.searchParams.set('universal', String(state.includeUniversal));
    return url.pathname + url.search + url.hash;
  }
  function searchVideoPlayer(value, startSeconds) {
    let url;
    try { url = new URL(value); } catch (_) { return null; }
    if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
    const host = url.hostname, path = url.pathname;
    let id, provider;
    if (['youtube.com','www.youtube.com','m.youtube.com'].includes(host)) {
      id = path === '/watch' ? url.searchParams.get('v') : path.match(/^\/(?:embed|shorts)\/([A-Za-z0-9_-]{11})\/?$/)?.[1];
    } else if (['youtu.be','www.youtu.be'].includes(host)) id = path.slice(1).replace(/\/$/, '');
    else if (['youtube-nocookie.com','www.youtube-nocookie.com'].includes(host)) id = path.match(/^\/embed\/([A-Za-z0-9_-]{11})\/?$/)?.[1];
    if (id && /^[A-Za-z0-9_-]{11}$/.test(id)) provider = 'YouTube';
    else if (['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(host)) {
      id = path.match(/^\/(?:video\/)?([0-9]{1,15})\/?$/)?.[1];
      if (id) provider = 'Vimeo';
    }
    if (!provider) return null;
    // Prefer the indexed chapter; also understand ordinary shared timestamp links.
    let seconds = startSeconds;
    if (seconds == null) {
      const value = url.searchParams.get('start') || url.searchParams.get('t') || new URLSearchParams(url.hash.slice(1)).get('t') || '';
      const parts = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
      seconds = /^\d+$/.test(value) ? Number(value) : parts ? Number(parts[1] || 0) * 3600 + Number(parts[2] || 0) * 60 + Number(parts[3] || 0) : 0;
    }
    seconds = Number.isSafeInteger(seconds) && seconds >= 0 && seconds <= 86400 ? seconds : 0;
    const embed = new URL(provider === 'YouTube' ? 'https://www.youtube-nocookie.com/embed/' + id : 'https://player.vimeo.com/video/' + id);
    embed.searchParams.set('autoplay', '1');
    if (provider === 'YouTube') {
      embed.searchParams.set('playsinline', '1'); embed.searchParams.set('rel', '0');
      if (seconds) embed.searchParams.set('start', String(seconds));
    } else {
      embed.searchParams.set('dnt', '1');
      if (seconds) embed.hash = 't=' + seconds + 's';
    }
    return {src:embed.href, provider, startSeconds:seconds,
      thumbnailUrl:provider === 'YouTube' ? 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg' : null};
  }
  const helpers = { normalize, mergeVehicles, searchPath, collectionPath, vehicleLink, unique, searchVideoPlayer };
  if (typeof module !== 'undefined' && module.exports) { module.exports = helpers; return; }
  if (!global.document) return;
  // Product/article paint uses inline critical CSS. Keep dialogs and search from
  // initializing without their full styles, just as the former blocking link did.
  const discoveryStyles = document.querySelector('[data-hbr-discovery-styles]');
  if (discoveryStyles && discoveryStyles.media === 'print') {
    await new Promise(resolve => {
      const complete = () => {
        discoveryStyles.media = 'all';
        discoveryStyles.removeEventListener('load', complete);
        discoveryStyles.removeEventListener('error', complete);
        resolve();
      };
      discoveryStyles.addEventListener('load', complete);
      discoveryStyles.addEventListener('error', complete);
      if (discoveryStyles.sheet || discoveryStyles.media !== 'print') complete();
    });
  }
  const config = document.querySelector('[data-hbr-config]');
  if (!config || global.HybridGarage) return;
  config.dataset.hbrStartupMs = String(Math.round(performance.now()));
  const root = config.dataset.root || '/';
  let api;
  try { api = new URL(config.dataset.apiUrl); if (api.protocol !== 'https:' && api.hostname !== 'localhost') return; }
  catch (_) { return; }
  const proxy = config.dataset.proxyPath || '/apps/hybrid-garage';
  const signedIn = !!config.dataset.customer;
  const storageKey = 'hybrid.garage.guest.v1';
  // This cache contains only the public vehicle catalog, never a customer's garage.
  const groupsCacheKey = 'hybrid.garage.options.v1:' + api.href;
  const groupsCacheLifetime = 5 * 60 * 1000;
  const suggestionResponses = new Map();
  const dialog = document.getElementById('hbr-garage-dialog');
  const $ = selector => dialog.querySelector(selector);
  const el = (tag, text, className) => { const n = document.createElement(tag); if (text != null) n.textContent = text; if (className) n.className = className; return n; };
  const button = (text, action, className = 'hbr-button hbr-button--quiet') => {
    const n = el('button', text, className); n.type = 'button'; n.addEventListener('click', action); return n;
  };
  const link = (text, href, className) => { const n = el('a', text, className); n.href = href; return n; };
  let state;
  try { state = normalize(signedIn ? JSON.parse(config.dataset.initialState || 'null') : null); } catch (_) { state = normalize(null); }
  let groups = [], csrf = '', ready = false, dirty = false, saving = false, pending = false, conflict = false;
  let activityConsentRequired = true;
  let generation = 0, suggestionTimer, returnFocus, groupsPromise, suggestionAbort, resultsAbort, fitAbort, countsAbort, collectionAbort;
  let inFlightSave = null, lastTrackedSearch = '', pendingSearchActivity = null, countsKey = '';
  let guestLoaded = false, mergeOffered = false;
  let activeRequests = 0, publicRetryAt = 0, activityAbort, activityTimer, activityIdle;
  const activityQueue = [];
  let groupsReady = false, accountLoading = false, accountFailed = false;
  let pickerStep = 'make', pickerExpanded = true, garageManaging = false, renderedPickerExpanded, garageStayOnPage = false;
  let lastPublicGarageContext = '';
  const quickSwitcher = document.querySelector('[data-hbr-switcher]');
  const quickToggle = document.querySelector('[data-hbr-switcher-toggle]');
  const nativeSearchQuery = new URL(location.href).searchParams.get('q') || '';
  const filterSections = new Map();
  let filterDialog, currentFilters, currentSidebar;
  const originalLinks = new WeakMap();
  const privacyChoice = kind => global.Shopify?.customerPrivacy?.[kind + 'ProcessingAllowed']?.();
  const privacy = kind => privacyChoice(kind) === true;
  function notify(message) { $('[data-hbr-message]').textContent = message; }
  function groupLabel(id) { return groups.find(g => g.id === id)?.label || 'Vehicle group'; }
  function status(message) { document.querySelectorAll('[data-hbr-status]').forEach(n => { n.textContent = message; }); }
  function saveGuest() {
    try {
      if (!signedIn && privacy('preferences')) localStorage.setItem(storageKey, JSON.stringify(state));
      else if (privacyChoice('preferences') === false) localStorage.removeItem(storageKey);
    } catch (_) { notify('Your browser could not save this garage. You can still shop in this tab.'); }
  }
  async function request(path, options = {}, privateCall = false, timeoutMs = privateCall ? 10000 : 5000) {
    if (!privateCall && Date.now() < publicRetryAt) {
      const error = new Error('Please wait a moment before searching again.'); error.code = 'rate_limited'; error.status = 429; throw error;
    }
    activeRequests++; pauseActivity();
    const ownAbort = new AbortController();
    const timer = setTimeout(() => ownAbort.abort(), timeoutMs);
    const signal = options.signal ? AbortSignal.any([options.signal, ownAbort.signal]) : ownAbort.signal;
    try {
      const canRetry = !privateCall && (options.method || 'GET').toUpperCase() === 'GET';
      for (let attempt = 0; ; attempt++) {
        signal.throwIfAborted();
        const response = await fetch(privateCall ? proxy + path : api.href.replace(/\/$/, '') + path,
          { ...options, signal, credentials: privateCall ? 'same-origin' : 'omit',
            headers: { Accept: 'application/json', ...(options.body != null ? { 'Content-Type': 'application/json' } : {}), ...options.headers } });
        const body = response.status === 204 ? null : await response.json();
        if (!privateCall && response.status === 429) {
          const seconds = Number(response.headers?.get('Retry-After')) || 2;
          publicRetryAt = Date.now() + Math.max(1, Math.min(60, seconds)) * 1000;
        }
        // Retry one bounded public read after a transient server timeout. Both attempts
        // share the same deadline/cancellation; private requests and writes never retry here.
        if (canRetry && attempt === 0 && response.status === 503 && body?.error === 'service_timeout') continue;
        if (!response.ok) { const e = new Error(body?.message || 'Vehicle services are unavailable.'); e.code = body?.error; e.status = response.status; throw e; }
        return body;
      }
    } finally { clearTimeout(timer); activeRequests--; scheduleActivity(); }
  }
  async function privateWrite(path, payload) {
    if (!csrf) throw new Error('Sign in and reload your garage to save this change.');
    try { return await request(path, { method: 'POST', body: JSON.stringify({ csrfToken: csrf, payload }) }, true); }
    catch (error) {
      if (error.code !== 'invalid_session') throw error;
      const session = await request('/garage', {}, true); csrf = session.csrfToken;
      return request(path, { method: 'POST', body: JSON.stringify({ csrfToken: csrf, payload }) }, true);
    }
  }
  function cachedGroups() {
    try {
      const value = JSON.parse(sessionStorage.getItem(groupsCacheKey) || 'null');
      const age = Date.now() - value?.savedAt;
      if (!Number.isFinite(age) || age < 0 || age >= groupsCacheLifetime || !Array.isArray(value?.groups)
        || !value.groups.every(g => g && typeof g.id === 'string' && uuid.test(g.id)
          && typeof g.label === 'string' && typeof g.make === 'string' && typeof g.model === 'string')) return null;
      return value;
    } catch (_) { return null; }
  }
  async function ensureGroups() {
    if (!groupsPromise) {
      fillSelect($('[data-hbr-make]'), [], 'Loading choices...');
      $('[data-hbr-retry-vehicles]').hidden = true;
      $('[data-hbr-vehicle-message]').hidden = true;
      $('[data-hbr-choose]').disabled = true;
      const cached = cachedGroups();
      groupsPromise = (cached ? Promise.resolve(cached) : request('/v1/vehicles/options')).then(data => {
        groups = data.groups.filter(g => ['honda', 'acura'].includes((g.make || '').trim().toLowerCase()))
          .map(g => ({ ...g, id: g.id.toLowerCase() })); groupsReady = true;
        if (!cached) {
          try { sessionStorage.setItem(groupsCacheKey, JSON.stringify({ savedAt: Date.now(), groups })); } catch (_) { /* Storage is optional. */ }
        }
        config.dataset.hbrVehiclesSource = cached ? 'session' : 'network';
        config.dataset.hbrVehiclesMs = String(Math.round(performance.now()));
        loadGuest(false);
        if (!dirty) applyUrlContext();
        fillMakes(); renderState();
        refreshResults(); refreshFit(); updateCollectionContext(true); refreshCounts();
        return groups;
      }).catch(error => {
        groupsPromise = null;
        fillSelect($('[data-hbr-make]'), [], 'Choices unavailable');
        $('[data-hbr-vehicle-message]').textContent = 'Vehicle choices could not be loaded. Try again, or continue browsing all parts.';
        $('[data-hbr-vehicle-message]').hidden = false;
        $('[data-hbr-retry-vehicles]').hidden = false;
        throw error;
      });
    }
    return groupsPromise;
  }
  function searchParameters(query, extra = {}) {
    const normalizedQuery = query.trim().replace(/\s+/g, ' ').toLowerCase();
    const p = new URLSearchParams({ q: normalizedQuery, groups: state.selectedGroupIds.join(','), universal: String(state.includeUniversal), country: config.dataset.country });
    setQueryValues(p, extra);
    return p.toString();
  }
  function searchDestination(query) {
    const url = new URL(searchPath(root, state, query), location.origin);
    // Keep incoming vehicle context until options can validate it. An outage must
    // not turn a vehicle-specific link into an unfiltered search.
    if (!groupsReady) {
      const current = new URL(location.href).searchParams;
      for (const key of ['groups', 'universal', 'filter.p.m.pim.vehicle_fitment']) {
        if (!current.has(key)) continue;
        url.searchParams.delete(key);
        current.getAll(key).forEach(value => url.searchParams.append(key, value));
      }
    }
    return url.pathname + url.search;
  }
  function requestErrorCode(error) {
    return error.name === 'AbortError' ? 'request_timeout' : typeof error.code === 'string' ? error.code : 'request_failed';
  }
  function selectedLabel() {
    return state.selectedGroupIds.length > 1 ? state.selectedGroupIds.length + ' vehicle groups' : state.selectedGroupIds.length ? groupLabel(state.selectedGroupIds[0]) : 'Shop for your car';
  }
  function navigationContextReady() {
    const params = new URL(location.href).searchParams;
    return signedIn || guestLoaded || dirty || privacyChoice('preferences') !== undefined
      || params.has('groups') || params.has('filter.p.m.pim.vehicle_fitment');
  }
  function browsingLink(href) {
    return navigationContextReady() ? vehicleLink(href, location.origin, state, groups) : href;
  }
  function updateNavigationLinks() {
    // Empty state while consent is loading is not an intentional "all parts"
    // choice. Do not put groups= on links and erase a saved car on the next page.
    if (!groupsReady || !navigationContextReady()) return;
    // Keep the older Shopify facet aligned with the same allowed groups as the garage.
    const allowedLabels = new Set(groups.map(group => group.label));
    document.querySelectorAll('input[name="filter.p.m.pim.vehicle_fitment"]').forEach(input => {
      if (input.closest('[data-hbr-collection-filters]')) return;
      if (!allowedLabels.has(input.value)) {
        input.disabled = true;
        input.closest('label')?.classList.add('hbr-blocked-vehicle-choice');
      }
    });
    document.querySelectorAll('a[href]').forEach(anchor => {
      const href = originalLinks.get(anchor) || anchor.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      try {
        const url = new URL(href, location.origin);
        // Shopify's in-place facet and paging links own the current collection URL.
        if (url.pathname === location.pathname && url.pathname.includes('/collections/')) return;
        const next = vehicleLink(href, location.origin, state, groups);
        if (next !== href) { originalLinks.set(anchor, href); anchor.setAttribute('href', next); }
      } catch (_) { /* Ignore non-navigation links. */ }
    });
  }
  function renderPicker() {
    if (renderedPickerExpanded !== pickerExpanded) $('.hbr-garage__body').scrollTop = 0;
    renderedPickerExpanded = pickerExpanded;
    $('[data-hbr-overview]').hidden = pickerExpanded;
    $('[data-hbr-picker-pane]').hidden = !pickerExpanded;
    $('[data-hbr-garage-back]').hidden = !state.vehicles.length;
    $('[data-hbr-choose]').hidden = !pickerExpanded;
    $('[data-hbr-shop-link]').hidden = pickerExpanded;
    const selects = { make: $('[data-hbr-make]'), model: $('[data-hbr-model]'), group: $('[data-hbr-group]') };
    const picked = groups.find(g => g.id === selects.group.value);
    $('[data-hbr-preferences]').hidden = pickerExpanded ? !picked : !garageManaging;
    const steps = ['make', 'model', 'group'];
    dialog.querySelectorAll('[data-hbr-step]').forEach(n => {
      const step = n.dataset.hbrStep;
      n.disabled = !groupsReady || (step === 'model' && !selects.make.value) || (step === 'group' && !selects.model.value);
      if (step === pickerStep) n.setAttribute('aria-current', 'step'); else n.removeAttribute('aria-current');
      const text = step === 'group' ? picked?.label : selects[step].value;
      n.querySelector('[data-hbr-step-value]').textContent = text || (step === 'group' ? 'Choose range' : 'Choose ' + step);
    });
    $('[data-hbr-step-count]').textContent = 'Step ' + (steps.indexOf(pickerStep) + 1) + ' of 3';
    $('[data-hbr-picker-title]').textContent = pickerStep === 'make' ? 'Choose your make' : pickerStep === 'model' ? 'Which ' + selects.make.value + '?' : 'Choose your year range';
    $('[data-hbr-picker-help]').textContent = pickerStep === 'make' ? 'Honda and Acura. Find your starting point.' : pickerStep === 'model' ? 'Select the model you want to shop for.' : 'Choose the group that includes your car.';
    const choices = $('[data-hbr-options]'); choices.dataset.step = pickerStep; choices.replaceChildren();
    choices.hidden = pickerStep === 'group';
    $('[data-hbr-range-field]').hidden = pickerStep !== 'group';
    if (!groupsReady) choices.append(el('p', groupsPromise ? 'Loading vehicle choices...' : 'Vehicle choices are unavailable.', 'hbr-muted'));
    else if (pickerStep !== 'group') for (const option of [...selects[pickerStep].options].filter(o => o.value)) {
      const tile = button(option.textContent, () => {
        const step = pickerStep;
        selects[step].value = option.value;
        selects[step].dispatchEvent(new Event('change', { bubbles: true }));
        $('[data-hbr-picker-title]').focus();
      }, 'hbr-vehicle-option');
      tile.dataset.hbrChoice = option.value;
      tile.setAttribute('aria-pressed', String(selects[pickerStep].value === option.value));
      choices.append(tile);
    }
    $('[data-hbr-picker-save]').hidden = !picked || pickerStep !== 'group';
    $('[data-hbr-selection-note]').textContent = picked ? 'Shopping for ' + picked.label + '. Save it below to find it again.' : '';
    positionGarage();
  }
  function closeQuickSwitcher(restoreFocus = false) {
    if (!quickSwitcher) return;
    quickSwitcher.hidden = true;
    quickToggle.setAttribute('aria-expanded', 'false');
    if (restoreFocus) quickToggle.focus();
  }
  function renderQuickSwitcher() {
    if (!quickSwitcher) return;
    const focused = quickSwitcher.contains(document.activeElement) ? document.activeElement.dataset.hbrSwitchGroup || 'edit' : null;
    quickSwitcher.replaceChildren(el('p', 'Your saved cars', 'hbr-switcher-heading'));
    if (!state.vehicles.length) quickSwitcher.append(el('p', signedIn && accountLoading ? 'Loading your garage...' : 'No saved cars yet.', 'hbr-switcher-empty'));
    for (const car of state.vehicles) {
      const group = groups.find(g => g.id === car.groupId);
      const choice = button(null, () => {
        closeQuickSwitcher(true);
        $('[data-hbr-multiple]').checked = false;
        changeSelection([car.groupId]);
      }, 'hbr-switcher-car');
      choice.dataset.hbrSwitchGroup = car.groupId;
      choice.setAttribute('aria-pressed', String(state.selectedGroupIds.includes(car.groupId)));
      choice.disabled = !groupsReady || !group;
      const mark = el('span', state.selectedGroupIds.includes(car.groupId) ? '✓' : '', 'hbr-switcher-check'); mark.setAttribute('aria-hidden', 'true');
      const copy = el('span'); copy.append(el('strong', group?.label || car.label));
      if (group && car.label !== group.label) copy.append(el('small', car.label));
      if (groupsReady && !group) copy.append(el('small', 'Vehicle unavailable'));
      choice.append(mark, copy); quickSwitcher.append(choice);
    }
    const edit = button('Edit garage', () => { closeQuickSwitcher(); openGarage(quickToggle, true); }, 'hbr-switcher-edit');
    edit.dataset.hbrSwitchEdit = ''; quickSwitcher.append(edit);
    if (focused) (focused === 'edit' ? edit : [...quickSwitcher.querySelectorAll('[data-hbr-switch-group]')].find(n => n.dataset.hbrSwitchGroup === focused))?.focus();
  }
  function toggleQuickSwitcher() {
    if (!quickSwitcher.hidden) { closeQuickSwitcher(true); return; }
    hideSuggestions(); renderQuickSwitcher(); quickSwitcher.hidden = false; quickToggle.setAttribute('aria-expanded', 'true');
    (quickSwitcher.querySelector('[aria-pressed=true]:not(:disabled)') || quickSwitcher.querySelector('button:not(:disabled)'))?.focus();
    if (!groupsReady) ensureGroups().catch(() => renderQuickSwitcher());
  }
  function positionGarage() {
    if (!dialog.open || global.innerWidth < 1024) { delete dialog.dataset.desktopAnchored; return; }
    const anchor = [...document.querySelectorAll('.hbr-header-desktop .hbr-garage-entry')].find(n => n.getBoundingClientRect().width > 0) || returnFocus;
    const rect = anchor?.getBoundingClientRect();
    if (!rect?.width) { delete dialog.dataset.desktopAnchored; return; }
    const width = dialog.getBoundingClientRect().width;
    const top = Math.max(16, Math.min(rect.bottom + 10, global.innerHeight - 240));
    const left = Math.max(16, Math.min(rect.right - width, global.innerWidth - width - 16));
    dialog.style.setProperty('--hbr-garage-top', top + 'px');
    dialog.style.setProperty('--hbr-garage-left', left + 'px');
    dialog.dataset.desktopAnchored = '';
  }
  function updatePickerActions() {
    const picked = $('[data-hbr-group]').value;
    const id = picked;
    $('[data-hbr-choose]').disabled = !groupsReady || !picked;
    $('[data-hbr-save-current]').disabled = !groupsReady || !id || !groups.some(g => g.id === id)
      || (signedIn && !ready) || conflict || state.vehicles.some(v => v.groupId === id);
    renderPicker();
  }
  function renderState() {
    document.querySelectorAll('[data-hbr-vehicle-label]').forEach(n => { n.textContent = selectedLabel(); });
    document.querySelectorAll('[data-hbr-search]').forEach(form => {
      const hasVehicle = state.selectedGroupIds.length > 0;
      const mobile = form.classList.contains('hbr-search-mobile');
      form.classList.toggle('hbr-has-vehicle', hasVehicle);
      const trigger = form.querySelector('[data-hbr-open], [data-hbr-switcher-toggle]');
      if (trigger) trigger.setAttribute('aria-label', (mobile ? 'For ' : 'Shopping for ') + selectedLabel() + (hasVehicle ? '. Change vehicle' : '. Add vehicle to your garage'));
      const change = form.querySelector('[data-hbr-vehicle-change]');
      if (change) change.textContent = hasVehicle ? 'Change' : 'Add vehicle';
      const eyebrow = form.querySelector('[data-hbr-vehicle-eyebrow]');
      if (eyebrow) eyebrow.textContent = mobile ? 'For' : 'Shopping for';
      const model = state.selectedGroupIds.length === 1 ? groups.find(g => g.id === state.selectedGroupIds[0])?.model : '';
      form.querySelector('input[name=q]').placeholder = model ? 'Search parts for your ' + model : hasVehicle ? 'Search parts for your cars' : mobile ? 'Search parts' : 'Search parts, brands, or part numbers';
    });
    document.querySelectorAll('[data-hbr-garage-count]').forEach(n => { n.textContent = state.vehicles.length; });
    $('[data-hbr-universal]').checked = state.includeUniversal;
    if (state.selectedGroupIds.length > 1) $('[data-hbr-multiple]').checked = true;
    $('[data-hbr-shop-link]').href = searchPath(root, state);
    $('[data-hbr-shop-link] span').textContent = state.selectedGroupIds.length > 1 ? 'Shop selected cars' : state.selectedGroupIds.length ? 'Shop this car' : 'Browse all parts';
    updatePickerActions();
    $('[data-hbr-multiple]').closest('label').hidden = state.vehicles.length < 2 && state.selectedGroupIds.length < 2;
    $('[data-hbr-persistence]').textContent = signedIn ? (ready ? 'Your account garage' : accountFailed ? 'Account connection unavailable. Try again below.' : 'Connecting to your account...')
      : privacy('preferences') ? 'Saved on this device only.' : 'Saved for this visit. Sign in to keep your garage.';
    const list = $('[data-hbr-saved]'); list.replaceChildren();
    if (!state.vehicles.length) list.append(el('p', 'Your garage is ready for its first car.', 'hbr-empty-garage'));
    for (const car of state.vehicles) {
      const row = el('div', null, 'hbr-saved-car');
      const label = el('label', null, 'hbr-saved-choice');
      const input = document.createElement('input'); input.type = $('[data-hbr-multiple]').checked ? 'checkbox' : 'radio'; input.name = 'hbr-active-car'; input.checked = state.selectedGroupIds.includes(car.groupId);
      input.disabled = !groupsReady || !groups.some(g => g.id === car.groupId);
      input.addEventListener('change', () => {
        const ids = input.type === 'radio' ? [car.groupId] : input.checked ? [...state.selectedGroupIds, car.groupId] : state.selectedGroupIds.filter(id => id !== car.groupId);
        if (unique(ids).length > 5) { input.checked = false; notify('Select up to five groups at once.'); return; }
        changeSelection(ids);
      });
      const group = groups.find(g => g.id === car.groupId);
      const text = el('span'); text.append(el('strong', groupLabel(car.groupId)), el('small', input.disabled && groupsReady ? 'This vehicle group is no longer available' : (group?.make || 'Vehicle') + ' · Vehicle group'));
      label.append(input, text); row.append(label);
      if (car.label !== groupLabel(car.groupId)) row.append(el('span', car.label, 'hbr-car-nickname'));
      const actions = el('div', null, 'hbr-car-actions'); actions.hidden = !garageManaging;
      actions.append(button('Rename', () => {
        if (signedIn && (!ready || conflict)) { notify('Connect your account before editing saved cars.'); return; }
        const field = el('input'); field.type = 'text'; field.maxLength = 80; field.value = car.label; field.setAttribute('aria-label', 'Vehicle nickname');
        const save = button('Save name', () => { if (!field.value.trim()) return; car.label = field.value.trim(); changed(false); renderState(); });
        row.replaceChildren(field, save, button('Cancel', renderState)); field.focus();
      }));
      actions.append(button('Remove', () => {
        if (signedIn && (!ready || conflict)) { notify('Connect your account before editing saved cars.'); return; }
        state.vehicles = state.vehicles.filter(v => v.id !== car.id);
        state.selectedGroupIds = state.selectedGroupIds.filter(id => id !== car.groupId);
        changed(); notify('Vehicle removed from your garage.');
      }));
      row.append(actions);
      list.append(row);
    }
    $('[data-hbr-manage]').hidden = !state.vehicles.length;
    $('[data-hbr-manage]').setAttribute('aria-pressed', String(garageManaging));
    $('[data-hbr-manage]').firstChild.textContent = garageManaging ? 'Done managing ' : 'Manage garage ';
    renderQuickSwitcher();
    updateNavigationLinks();
    const publicContext = JSON.stringify([state.selectedGroupIds.map(id => [id, groupLabel(id)]), state.includeUniversal]);
    if (publicContext !== lastPublicGarageContext) {
      lastPublicGarageContext = publicContext;
      document.dispatchEvent(new CustomEvent('hybrid:garagestate'));
    }
  }
  async function persist() {
    if (!signedIn) { loadGuest(false); saveGuest(); return; }
    pending = true;
    if (!ready || saving || conflict) return;
    saving = true;
    try {
      while (pending) {
        pending = false;
        const payload = inFlightSave || { requestId: crypto.randomUUID(), expectedRevision: state.revision,
          vehicles: structuredClone(state.vehicles), selectedGroupIds: [...state.selectedGroupIds], includeUniversal: state.includeUniversal };
        const retrying = !!inFlightSave;
        inFlightSave = payload;
        notify('Saving your garage...');
        const saved = await privateWrite('/garage', payload);
        if (saved.revision !== payload.expectedRevision + 1) {
          const error = new Error('Your garage changed on another device. Reload before saving.'); error.status = 409; throw error;
        }
        inFlightSave = null;
        if (retrying && JSON.stringify({ vehicles: state.vehicles, groups: state.selectedGroupIds, universal: state.includeUniversal }) !==
          JSON.stringify({ vehicles: payload.vehicles, groups: payload.selectedGroupIds, universal: payload.includeUniversal })) pending = true;
        state.revision = saved.revision; dirty = pending;
        notify('Saved to your account.');
        $('[data-hbr-retry-save]').hidden = true;
      }
    } catch (error) {
      dirty = true; pending = true; conflict = error.status === 409;
      notify(error.message + ' Your browsing selection is still available in this tab.');
      $('[data-hbr-retry-save]').hidden = false;
    } finally { saving = false; }
  }
  function changed(refresh = true) {
    dirty = true; generation++;
    if (refresh && !document.querySelector('[data-hbr-collection]')) {
      // Reload must restore the current selection, including an explicit clear,
      // instead of an older car carried in the incoming product/page URL.
      const url = new URL(location.href); url.searchParams.set('groups', state.selectedGroupIds.join(','));
      url.searchParams.set('universal', String(state.includeUniversal)); url.searchParams.delete('hbr_page');
      history.replaceState(history.state, '', url);
    }
    renderState(); persist();
    if (refresh) {
      refreshResults(); refreshFit(); updateCollectionContext(true); refreshCounts();
    }
    hideSuggestions();
    document.dispatchEvent(new CustomEvent('hybrid:vehiclechange', { detail: { groupIds: [...state.selectedGroupIds] } }));
  }
  function changeSelection(ids) { state.selectedGroupIds = unique(ids).slice(0, 5); changed(); fillMakes(); }
  async function openGarage(trigger, manage = false, stayOnPage = false) {
    garageStayOnPage = stayOnPage;
    closeQuickSwitcher(); hideSuggestions();
    returnFocus = trigger; pickerExpanded = !state.vehicles.length; garageManaging = manage && !!state.vehicles.length;
    renderState(); dialog.showModal(); positionGarage(); $('[data-hbr-close]').focus();
    try { await ensureGroups(); fillMakes(); pickerStep = $('[data-hbr-group]').value ? 'group' : 'make'; renderState(); refreshCounts(); } catch (_) { renderPicker(); /* The picker shows its own failure and retry action. */ }
  }
  function fillSelect(select, values, placeholder) {
    select.replaceChildren(new Option(placeholder, ''));
    values.forEach(([value, text]) => select.add(new Option(text, value)));
    select.disabled = !values.length;
  }
  function fillMakes() {
    fillSelect($('[data-hbr-make]'), [...new Set(groups.map(g => g.make))].sort().map(m => [m, m]), 'Choose make');
    fillSelect($('[data-hbr-model]'), [], 'Choose model'); fillSelect($('[data-hbr-group]'), [], 'Choose year range');
    const current = state.selectedGroupIds.length === 1 && groups.find(g => g.id === state.selectedGroupIds[0]);
    if (current) {
      $('[data-hbr-make]').value = current.make;
      fillSelect($('[data-hbr-model]'), [...new Set(groups.filter(g => g.make === current.make).map(g => g.model))].sort().map(m => [m, m]), 'Choose model');
      $('[data-hbr-model]').value = current.model;
      fillSelect($('[data-hbr-group]'), groups.filter(g => g.make === current.make && g.model === current.model).map(g => [g.id, g.label]), 'Choose year range');
      $('[data-hbr-group]').value = current.id;
    }
    updatePickerActions();
  }
  async function syncAccount() {
    if (!signedIn || accountLoading) return;
    accountLoading = true; accountFailed = false; renderState();
    try {
      const data = await request('/garage', {}, true);
      csrf = data.csrfToken;
      // Only the authenticated API can grant the temporary test-account exception.
      activityConsentRequired = data.activityPolicy?.requiresAnalyticsConsent !== false;
      config.dataset.hbrActivityConsentRequired = String(activityConsentRequired);
      const previousContext = JSON.stringify([state.selectedGroupIds, state.includeUniversal]);
      if (!dirty) { state = normalize(data.state); if (groupsReady) applyUrlContext(); }
      else { state.revision = data.state.revision; state.vehicles = normalize(data.state).vehicles; }
      ready = true;
      if (groupsReady && !dirty) fillMakes();
      if (!pending && !inFlightSave) $('[data-hbr-retry-save]').hidden = true;
      renderState();
      if (previousContext !== JSON.stringify([state.selectedGroupIds, state.includeUniversal])) {
        generation++; refreshResults(); refreshFit(); updateCollectionContext(true); refreshCounts();
      }
      if (pending) persist();
      offerGuestMerge();
    } catch (_) {
      ready = false; csrf = ''; accountFailed = true; activityConsentRequired = true;
      config.dataset.hbrActivityConsentRequired = 'true';
      notify('Account garage is unavailable. Your current browsing selection still works.');
      $('[data-hbr-retry-save]').hidden = false; renderState();
    } finally { accountLoading = false; trackPendingSearch(); }
  }
  function offerGuestMerge() {
    if (!signedIn || !ready || !privacy('preferences') || mergeOffered) return;
    mergeOffered = true;
    try {
      const guest = normalize(JSON.parse(localStorage.getItem(storageKey) || 'null'));
      if (!guest.vehicles.some(car => !state.vehicles.some(v => v.groupId === car.groupId)) || localStorage.getItem(storageKey + '.dismissed') === JSON.stringify(guest.vehicles)) return;
      const prompt = $('[data-hbr-merge]'); prompt.hidden = false; prompt.replaceChildren(el('p', 'Add the cars saved on this device to your account?'));
      prompt.append(button('Add saved cars', async () => {
        state.vehicles = mergeVehicles(state.vehicles, guest.vehicles); changed(false); prompt.hidden = true;
        // Keep the offer eligible after a failed save; already-merged groups are not offered again.
      }), button('Not now', () => { localStorage.setItem(storageKey + '.dismissed', JSON.stringify(guest.vehicles)); prompt.hidden = true; }));
    } catch (_) { /* Private storage can be blocked independently of consent. */ }
  }
  function loadGuest(refresh = true) {
    const allowed = privacyChoice('preferences');
    // An unavailable consent API is not a declined preference. Do not erase a
    // saved garage while Shopify's consent script is still downloading.
    if (allowed !== true) {
      if (allowed === false) { try { localStorage.removeItem(storageKey); localStorage.removeItem(storageKey + '.dismissed'); } catch (_) {} }
      return;
    }
    if (!signedIn && !guestLoaded) {
      try {
        const saved = normalize(JSON.parse(localStorage.getItem(storageKey) || 'null'));
        // A visitor may choose a car before Shopify finishes loading consent.
        // Keep that new choice, but do not discard their previously saved cars.
        state = dirty ? { ...state, vehicles: mergeVehicles(state.vehicles, saved.vehicles) } : saved;
        guestLoaded = true;
      } catch (_) { return; }
      if (groupsReady && !dirty) applyUrlContext();
      else if (dirty) saveGuest();
      if (groupsReady) fillMakes();
      renderState();
      if (refresh && groups.length) { refreshResults(); refreshFit(); updateCollectionContext(true); }
    }
    offerGuestMerge();
  }
  let consentTimer, consentAttempts = 0, consentRequested = false;
  function initializePreferences() {
    clearTimeout(consentTimer);
    if (typeof global.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') {
      loadGuest(); renderState(); trackPendingSearch(); return;
    }
    if (global.Shopify?.loadFeatures) {
      if (!consentRequested) {
        consentRequested = true;
        global.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => { loadGuest(); renderState(); trackPendingSearch(); });
      }
      return;
    }
    // Garage runs before other deferred scripts. Start consent loading as soon
    // as Shopify's loader is ready, without waiting for the remaining app scripts.
    if (++consentAttempts <= 100) consentTimer = setTimeout(initializePreferences, 100);
  }
  function applyUrlContext() {
    const params = new URL(location.href).searchParams;
    if (params.has('groups')) state.selectedGroupIds = unique(params.get('groups').split(',')).filter(id => groups.some(g => g.id === id)).slice(0, 5);
    else if (params.has('filter.p.m.pim.vehicle_fitment')) {
      const labels = params.getAll('filter.p.m.pim.vehicle_fitment');
      state.selectedGroupIds = groups.filter(g => labels.includes(g.label)).map(g => g.id).slice(0, 5);
    }
    state.selectedGroupIds = state.selectedGroupIds.filter(id => groups.some(g => g.id === id));
    if (params.has('universal')) state.includeUniversal = params.get('universal') !== 'false';
    const native = document.querySelector('[data-hbr-collection]');
    const group = native && groups.find(g => g.collectionHandle === native.dataset.handle || g.label === native.dataset.vehicleLabel);
    if (group && !params.has('groups') && !params.has('filter.p.m.pim.vehicle_fitment')) state.selectedGroupIds = [group.id];
    // Remember explicit navigation choices only after loading existing guest data.
    // Otherwise a late consent callback could replace the saved garage with empty data.
    if (!signedIn && guestLoaded && groupsReady) saveGuest();
    renderState();
  }
  function fitBadge(fit) {
    if (fit.status === 'universal') return el('span', 'Universal', 'hbr-product-fit hbr-product-fit--universal');
    const listed = fit.status === 'group-listed';
    const badge = el('span', null, 'hbr-product-fit' + (listed ? ' hbr-product-fit--listed' : ''));
    const context = state.selectedGroupIds.length > 1 ? groupLabel(fit.groupId) : '';
    if (listed) {
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('viewBox', '0 0 20 20'); icon.setAttribute('class', 'hbr-fit-icon');
      icon.setAttribute('aria-hidden', 'true'); icon.setAttribute('focusable', 'false');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M4 10.5 8 14.5 16 5.5');
      icon.append(path);
      badge.append(icon);
      const copy = el('span', null, 'hbr-fit-copy');
      copy.append(el('span', 'Fits your Vehicle', 'hbr-fit-label'));
      if (context) copy.append(el('small', context, 'hbr-fit-note'));
      badge.title = (context ? context + ': ' : '') + 'Vehicle-group match. Verify product application notes and options for exact fit.';
      badge.append(copy);
    } else badge.textContent = (context ? context + ': ' : '') + fit.label;
    return badge;
  }
  function card(product, compact = false) {
    const a = link('', browsingLink(root + 'products/' + encodeURIComponent(product.handle)), compact ? 'hbr-suggestion-card' : 'hbr-result-card');
    a.dataset.hbrSaleHandle = product.handle;
    const media = el('div', null, compact ? 'hbr-card-media hbr-suggestion-media' : 'hbr-card-media');
    if (product.imageUrl) {
      try {
        const imageUrl = new URL(product.imageUrl);
        if (imageUrl.protocol === 'https:' && (imageUrl.hostname.endsWith('.shopify.com') || imageUrl.origin === location.origin)) {
          const image = el('img'); image.src = imageUrl.href; image.alt = ''; image.loading = 'lazy'; image.width = compact ? 72 : 300; image.height = compact ? 72 : 300; media.append(image);
        }
      } catch (_) {}
    }
    if (!media.childElementCount) media.append(el('span', 'View product', 'hbr-card-placeholder'));
    a.append(media);
    const content = el('div', null, compact ? 'hbr-suggestion-content' : 'hbr-card-content');
    content.append(el('small', product.brand || '', 'hbr-muted'), el(compact ? 'strong' : 'h3', product.title));
    if (!compact && product.priceMin != null && product.currency === config.dataset.currency) {
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: product.currency });
      content.append(el('p', (product.priceMax > product.priceMin ? 'From ' : '') + money.format(product.priceMin), 'hbr-price'));
      a.dataset.hbrPriceMin = String(Math.round(product.priceMin * 100));
    } else content.append(el('p', compact ? 'View price' : 'View options and price', 'hbr-price'));
    if (state.selectedGroupIds.length) {
      for (const fit of product.fits) {
        if (fit.status === 'universal' || (compact && fit.status === 'not-confirmed')) continue;
        content.append(fitBadge(fit));
      }
      if (product.fits.some(fit => fit.status === 'universal')) content.append(fitBadge({status:'universal'}));
    } else if (product.universal) content.append(fitBadge({status:'universal'}));
    if (compact) {
      const meta = el('div', null, 'hbr-suggestion-meta');
      content.querySelectorAll('.hbr-price,.hbr-product-fit').forEach(item => meta.append(item));
      content.append(meta);
    } else {
      const price = content.querySelector('.hbr-price'); content.append(price);
      const cta = el('span', 'View part', 'hbr-card-action'); const arrow = el('span', '→'); arrow.setAttribute('aria-hidden', 'true'); cta.append(arrow); content.append(cta);
    }
    a.append(content); a.addEventListener('click', () => track('product-clicked', { productHandle: product.handle })); return a;
  }
  // The search index does not carry Shopify's market-specific compare-at prices.
  // Check visible cards without delaying search or requesting every page of products.
  const saleCache = new Map(), saleQueue = [];
  let saleObserver, activeSaleChecks = 0;
  function pumpSaleChecks() {
    while (activeSaleChecks < 4 && saleQueue.length) {
      const job = saleQueue.shift();
      if (![...job.cards].some(card => card.isConnected)) {
        if (saleCache.get(job.handle) === job) saleCache.delete(job.handle);
        job.resolve(null); continue;
      }
      activeSaleChecks++;
      const controller = new AbortController(), timer = setTimeout(() => controller.abort(), 4000);
      fetch(root + 'products/' + encodeURIComponent(job.handle) + '.js', {
        credentials:'same-origin', headers:{Accept:'application/json'}, signal:controller.signal
      }).then(response => {
        if (!response.ok) throw new Error('Product pricing unavailable');
        return response.json();
      }).then(product => {
        if (product.handle !== job.handle || !Array.isArray(product.variants)) throw new Error('Invalid product pricing');
        // Compare the price and compare-at value on the SAME variant, not range extrema.
        const variants = product.variants.filter(v => Number.isFinite(v.price) && v.price >= 0);
        if (!variants.length) throw new Error('Missing product pricing');
        const discounted = v => Number.isFinite(v.compare_at_price) && v.compare_at_price > v.price;
        const priceMin = Math.min(...variants.map(v => v.price));
        const lowest = variants.filter(v => v.price === priceMin);
        job.resolve({ onSale:variants.some(discounted), priceMin, priceMax:Math.max(...variants.map(v => v.price)),
          compareAt:lowest.length && lowest.every(discounted) ? Math.min(...lowest.map(v => v.compare_at_price)) : null });
      }).catch(() => {
        if (saleCache.get(job.handle) === job) saleCache.delete(job.handle);
        job.resolve(null); // Optional merchandising data must never break search results.
      }).finally(() => {
        clearTimeout(timer); job.cards.clear(); activeSaleChecks--; pumpSaleChecks();
      });
    }
  }
  function checkCardSale(card) {
    const handle = card.dataset.hbrSaleHandle;
    let job = saleCache.get(handle);
    if (!job || job.expires <= Date.now()) {
      job = {handle, cards:new Set(), expires:Date.now() + 60000};
      job.promise = new Promise(resolve => { job.resolve = resolve; });
      saleCache.set(handle, job); saleQueue.push(job);
      if (saleCache.size > 200) saleCache.delete(saleCache.keys().next().value);
    }
    job.cards.add(card);
    job.promise.then(pricing => {
      job.cards.delete(card);
      if (!card.isConnected || !pricing) return;
      // Shopify's locale-aware product endpoint supplies current-market prices,
      // including discounts that are not present in the PIM search index.
      if (card.classList.contains('hbr-suggestion-card')) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:config.dataset.currency });
        card.querySelector('.hbr-price').textContent = (pricing.priceMax > pricing.priceMin ? 'From ' : '') + money.format(pricing.priceMin / 100);
        card.dataset.hbrPriceMin = String(pricing.priceMin);
      }
      if (pricing.onSale && !card.querySelector('.hbr-card-sale'))
        card.querySelector('.hbr-card-media').append(el('span', 'Sale', 'hbr-card-sale'));
      // The original price must belong to the displayed starting price, in the
      // current market. Do not cross out a different variant's regular price.
      if (pricing.compareAt != null && card.dataset.hbrPriceMin !== undefined
        && Number(card.dataset.hbrPriceMin) === pricing.priceMin && !card.querySelector('.hbr-price-compare')) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency:config.dataset.currency });
        const original = el('s', money.format(pricing.compareAt / 100), 'hbr-price-compare');
        original.setAttribute('aria-label', 'Regular price ' + original.textContent);
        card.querySelector('.hbr-price').append(original);
      }
    });
    pumpSaleChecks();
  }
  function watchSaleBadges(container) {
    if (!saleObserver && global.IntersectionObserver) saleObserver = new IntersectionObserver(entries => {
      entries.filter(entry => entry.isIntersecting).forEach(entry => {
        saleObserver.unobserve(entry.target); checkCardSale(entry.target);
      });
    }, {rootMargin:'200px 0px'});
    saleObserver?.disconnect();
    container.querySelectorAll('[data-hbr-sale-handle]').forEach(card => {
      if (saleObserver) saleObserver.observe(card); else checkCardSale(card);
    });
  }
  function hideSuggestions() {
    clearTimeout(suggestionTimer); suggestionAbort?.abort();
    document.querySelectorAll('[data-hbr-search]').forEach(form => {
      form.querySelector('[data-hbr-suggestions]').hidden = true;
      form.querySelector('[data-hbr-suggestions]').removeAttribute('aria-busy');
      form.querySelector('input[name=q]').setAttribute('aria-expanded', 'false');
    });
  }
  function syncSearchInputs() {
    const query = new URL(location.href).searchParams.get('q') || '';
    document.querySelectorAll('[data-hbr-search] input[name=q]').forEach(input => { input.value = query; });
  }
  function updateSearchPage(href) {
    const target = document.querySelector('[data-hbr-results]'), destination = new URL(href, location.origin);
    if (!target || !groupsReady || destination.origin !== location.origin || destination.pathname !== root + 'search') return false;
    hideSuggestions(); closeQuickSwitcher();
    if (filterDialog?.open) filterDialog.close();
    history.pushState({}, '', destination);
    generation++; applyUrlContext(); fillMakes(); renderState(); syncSearchInputs();
    refreshResults();
    global.scrollTo(0, 0);
    return true;
  }
  function searchResultsLink(text, href, className) {
    const a = link(text, href, className); a.dataset.hbrSearchDestination = ''; return a;
  }
  function queueSuggestions(form) {
    pauseActivity();
    hideSuggestions();
    const input = form.querySelector('input[name=q]'), box = form.querySelector('[data-hbr-suggestions]');
    if (input.value.trim().length < 2) return;
    delete box.dataset.errorCode;
    const loading = el('p', 'Searching parts...', 'hbr-suggestion-status'); loading.setAttribute('role', 'status');
    box.replaceChildren(loading); box.hidden = false; box.setAttribute('aria-busy', 'true'); input.setAttribute('aria-expanded', 'true');
    const cached = suggestionResponses.get('/v1/suggestions?' + searchParameters(input.value.trim()));
    if (groupsReady && cached && Date.now() - cached.savedAt < 20000) suggestions(form);
    else suggestionTimer = setTimeout(() => suggestions(form), 80);
  }
  const resourceResponses = new Map();
  function resourceUrl(value) {
    try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password ? url.href : null; }
    catch (_) { return null; }
  }
  function videoChapters(item) {
    const seen = new Set();
    return (Array.isArray(item.chapters) ? item.chapters : []).filter(c => c && typeof c.title === 'string'
      && c.title.trim() && c.title.length <= 200 && Number.isInteger(c.startSeconds) && c.startSeconds >= 0
      && c.startSeconds <= 86400 && !seen.has(c.startSeconds) && seen.add(c.startSeconds))
      .sort((a, b) => a.startSeconds - b.startSeconds).slice(0, 100);
  }
  function videoTime(seconds) {
    return (seconds >= 3600 ? Math.floor(seconds / 3600) + ':' + String(Math.floor(seconds / 60) % 60).padStart(2, '0') : Math.floor(seconds / 60))
      + ':' + String(seconds % 60).padStart(2, '0');
  }
  function videoChapterUrl(item, seconds) {
    const player = searchVideoPlayer(item.url, seconds);
    if (!player) return null;
    const id = new URL(player.src).pathname.split('/').pop();
    return player.provider === 'YouTube' ? 'https://www.youtube.com/watch?v=' + id + '&t=' + seconds + 's'
      : 'https://vimeo.com/' + id + '#t=' + seconds + 's';
  }
  function bindVideoLink(anchor, item, player) {
    anchor.target = '_blank'; anchor.rel = 'noopener noreferrer';
    if (!player) return;
    anchor.setAttribute('aria-haspopup', 'dialog');
    anchor.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (openSearchVideo(item, player, anchor)) event.preventDefault();
    });
  }
  let videoDialog = null;
  function openSearchVideo(item, player, trigger) {
    if (typeof global.HTMLDialogElement?.prototype.showModal !== 'function') return false;
    videoDialog?.close();
    const modal = el('dialog', null, 'hbr-video-dialog');
    modal.setAttribute('aria-labelledby', 'hbr-video-title'); modal.setAttribute('aria-modal', 'true');
    const header = el('div', null, 'hbr-video-header'), heading = el('div', null, 'hbr-video-heading');
    heading.append(el('p', 'Hybrid Racing / Watch & learn', 'hbr-video-eyebrow'));
    const title = el('h2', item.title); title.id = 'hbr-video-title'; heading.append(title);
    const close = button('×', () => modal.close(), 'hbr-video-close'); close.setAttribute('aria-label', 'Close video');
    header.append(heading, close);
    const screen = el('div', null, 'hbr-video-screen');
    const chapters = videoChapters(item), chapterButtons = [];
    const chapterPanel = el('section', null, 'hbr-video-chapters');
    if (chapters.length) {
      chapterPanel.setAttribute('aria-labelledby', 'hbr-video-chapters-title');
      const label = el('h3', 'Jump to a moment'); label.id = 'hbr-video-chapters-title';
      const caption = el('div', null, 'hbr-moments-heading');
      caption.append(label, el('span', chapters.length + (chapters.length === 1 ? ' chapter' : ' chapters')));
      const list = el('div', null, 'hbr-video-chapter-list');
      chapters.forEach(chapter => {
        const jump = button('', () => playMoment(chapter.startSeconds, chapter.title), 'hbr-video-chapter');
        jump.dataset.startSeconds = String(chapter.startSeconds);
        jump.setAttribute('aria-label', 'Play ' + chapter.title + ' at ' + videoTime(chapter.startSeconds));
        jump.append(el('span', videoTime(chapter.startSeconds), 'hbr-moment-time'), el('span', chapter.title, 'hbr-moment-title'));
        chapterButtons.push(jump); list.append(jump);
      });
      chapterPanel.append(caption, list);
    }
    const footer = el('div', null, 'hbr-video-footer');
    const details = el('div', null, 'hbr-video-details');
    if (player.startSeconds || item.chapterTitle) {
      const seconds = player.startSeconds, time = videoTime(seconds);
      details.append(el('span', 'Starting at ' + time, 'hbr-video-timestamp'), el('span', item.chapterTitle || 'Selected moment', 'hbr-video-chapter-title'));
    } else details.append(el('span', 'Watch without leaving your search', 'hbr-video-chapter-title'));
    const actions = el('div', null, 'hbr-video-actions');
    const restart = button('Watch from start', () => playMoment(0, null), 'hbr-video-restart');
    restart.hidden = !player.startSeconds;
    actions.append(restart);
    actions.append(button('Back to results', () => modal.close(), 'hbr-video-done'));
    const fallback = link('Open on ' + player.provider + ' ↗', videoChapterUrl(item, player.startSeconds), 'hbr-video-external'); fallback.target = '_blank'; fallback.rel = 'noopener noreferrer';
    fallback.setAttribute('aria-label', 'Open on ' + player.provider + ' in a new tab');
    function markMoment(seconds) {
      chapterButtons.forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.startSeconds) === seconds)));
    }
    function playMoment(seconds, title) {
      const next = searchVideoPlayer(item.url, seconds); if (!next) return;
      frame.src = next.src; markMoment(seconds); restart.hidden = seconds === 0;
      fallback.href = videoChapterUrl(item, seconds);
      details.replaceChildren(...(title
        ? [el('span', 'Starting at ' + videoTime(seconds), 'hbr-video-timestamp'), el('span', title, 'hbr-video-chapter-title')]
        : [el('span', 'Playing from the beginning', 'hbr-video-chapter-title')]));
    }
    markMoment(player.startSeconds);
    footer.append(details, actions, fallback);
    modal.append(header, screen); if (chapters.length) modal.append(chapterPanel);
    modal.append(footer); document.body.append(modal);
    const fallbackFocus = trigger.closest('[data-hbr-search]')?.querySelector('input[name=q]');
    modal.addEventListener('close', () => {
      screen.replaceChildren(); modal.remove();
      if (videoDialog === modal) { videoDialog = null; document.documentElement.classList.remove('hbr-video-open'); }
      const focus = trigger.isConnected && trigger.getClientRects().length ? trigger : fallbackFocus;
      focus?.focus({preventScroll:true});
    }, {once:true});
    modal.addEventListener('cancel', event => { event.preventDefault(); modal.close(); });
    const outside = event => {
      const rect = modal.getBoundingClientRect();
      return event.target === modal && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    };
    let pressedOutside = false;
    modal.addEventListener('pointerdown', event => { pressedOutside = outside(event); });
    modal.addEventListener('click', event => { if (pressedOutside && outside(event)) modal.close(); });
    try { modal.showModal(); } catch (_) { modal.remove(); return false; }
    videoDialog = modal; document.documentElement.classList.add('hbr-video-open'); close.focus();
    // Create the provider frame only after this explicit watch action. Removing it stops audio.
    const frame = el('iframe'); frame.title = item.title + ' — ' + player.provider + ' video player';
    frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture'; frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin'; frame.src = player.src; screen.append(frame);
    return true;
  }
  global.addEventListener('pagehide', () => videoDialog?.close());
  function resourceCard(item, kind, compact, index, chapterLimit) {
    const href = resourceUrl(item.url); if (!href || item.documentType !== kind) return null;
    const a = link('', browsingLink(href), 'hbr-resource-card hbr-resource-card--' + kind);
    const player = kind === 'video' ? searchVideoPlayer(href, item.startSeconds) : null;
    const chapters = kind === 'video' && player ? videoChapters(item) : [];
    if (kind === 'video') bindVideoLink(a, item, player);
    // The browser fallback also covers videos indexed before automatic thumbnails were added.
    const image = resourceUrl(item.imageUrl) || player?.thumbnailUrl;
    const media = el('span', null, 'hbr-resource-media');
    if (image) {
      const img = el('img'); img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
      img.width = kind === 'video' ? 112 : 48; img.height = kind === 'video' ? 63 : 48;
      img.addEventListener('error', () => {
        img.remove();
        if (kind === 'brand') media.append(el('span', item.title.slice(0, 2), 'hbr-resource-placeholder'));
      }, {once:true});
      img.src = image; media.append(img);
    }
    else media.append(el('span', kind === 'video' ? '▶' : kind === 'brand' ? item.title.slice(0, 2) : '↗', 'hbr-resource-placeholder'));
    if (kind === 'video') { const play = el('span', '▶', 'hbr-resource-play'); play.setAttribute('aria-hidden', 'true'); media.append(play); }
    if (kind !== 'article') a.append(media);
    else { const number = el('span', String(index + 1).padStart(2, '0'), 'hbr-resource-number'); number.setAttribute('aria-hidden', 'true'); a.append(number); }
    const text = el('span', null, 'hbr-resource-copy');
    if (kind === 'brand') text.append(el('small', 'Shop the brand', 'hbr-resource-eyebrow'));
    text.append(el('strong', item.title));
    if (kind === 'article') text.append(el('small', 'ARTICLE' + (item.readingMinutes ? ' · ' + item.readingMinutes + ' min read' : '')));
    if (kind === 'video') {
      if (!chapters.length && Number.isInteger(item.startSeconds) && item.startSeconds >= 0) {
        const seconds = item.startSeconds, time = videoTime(seconds);
        text.append(el('span', '▶ ' + time + ' ' + (item.chapterTitle || 'Watch chapter'), 'hbr-resource-chapter'));
      }
      text.append(el('small', player ? 'Video · Watch here' : 'Video · Opens in a new tab'));
    }
    if (!compact && item.summary && kind === 'article') text.append(el('span', item.summary, 'hbr-resource-summary'));
    a.append(text);
    if (kind === 'brand') { const arrow = el('span', '→', 'hbr-resource-arrow'); arrow.setAttribute('aria-hidden', 'true'); a.append(arrow); }
    if (chapters.length) {
      const video = el('div', null, 'hbr-resource-video'); video.append(a);
      const cues = el('div', null, 'hbr-video-cues');
      // Keep the query's winning chapter within the preview budget, but display
      // all selected chapters chronologically. Quick search keeps only the match.
      const matched = chapters.find(c => c.startSeconds === item.startSeconds && item.chapterTitle);
      const preview = compact ? (matched ? [matched] : [])
        : (matched ? [matched, ...chapters.filter(c => c !== matched)] : chapters).slice(0, chapterLimit);
      preview.sort((a, b) => a.startSeconds - b.startSeconds);
      for (const chapter of preview) {
        const isMatch = chapter === matched;
        const jump = link('', videoChapterUrl(item, chapter.startSeconds), 'hbr-moment' + (isMatch ? ' hbr-moment--match' : '') + (compact ? ' hbr-moment--quick' : ''));
        jump.setAttribute('aria-label', 'Watch ' + (isMatch ? 'matching chapter ' : 'chapter ') + chapter.title + ' at ' + videoTime(chapter.startSeconds));
        jump.append(el('span', videoTime(chapter.startSeconds), 'hbr-moment-time'), el('span', chapter.title, 'hbr-moment-title'));
        const chapterItem = {...item, chapterTitle:chapter.title, startSeconds:chapter.startSeconds};
        bindVideoLink(jump, chapterItem, searchVideoPlayer(href, chapter.startSeconds)); cues.append(jump);
      }
      const all = link('View all ' + chapters.length + (chapters.length === 1 ? ' chapter' : ' chapters') + ' →', href, 'hbr-moments-summary');
      all.setAttribute('aria-label', 'View ' + chapters.length + (chapters.length === 1 ? ' chapter' : ' chapters') + ' in ' + item.title);
      bindVideoLink(all, item, player); cues.append(all);
      video.append(cues); return video;
    }
    return a;
  }
  async function loadSearchResources(container, query, parentSignal, compact) {
    if (config.dataset.searchResources !== 'true' || query.trim().length < 2) return;
    const slot = el('aside', null, 'hbr-search-resources' + (compact ? ' hbr-search-resources--compact' : ''));
    slot.hidden = true; slot.setAttribute('aria-label', 'Related brands, articles and videos');
    const productGrid = !compact && container.querySelector('.hbr-results-grid');
    if (productGrid) {
      const rowSize = typeof matchMedia === 'function' && matchMedia('(max-width:1100px)').matches ? 2 : 4;
      productGrid.insertBefore(slot, productGrid.children[rowSize] || null);
    } else if (compact) container.querySelector('.hbr-suggestion-layout').append(slot); else container.prepend(slot);
    const key = query.trim().toLowerCase().replace(/\s+/g, ' '), cached = resourceResponses.get(key);
    const controller = new AbortController(), abort = () => controller.abort();
    if (parentSignal.aborted) { slot.remove(); return; }
    parentSignal.addEventListener('abort', abort, { once: true });
    const timer = setTimeout(abort, 1800);
    try {
      let data = cached && Date.now() - cached.at < 15000 ? cached.data : null;
      if (!data) {
        const url = new URL('/v1/resources', api); url.searchParams.set('q', key);
        // Optional resources have their own timeout and budget. Their failures do
        // not trip the product-search retry delay or create analytics events.
        const response = await fetch(url.href, { signal: controller.signal, credentials: 'omit' });
        if (!response.ok) return;
        data = await response.json();
        if (data.status !== 'ok') return;
        resourceResponses.set(key, { at: Date.now(), data });
        if (resourceResponses.size > 20) resourceResponses.delete(resourceResponses.keys().next().value);
      }
      if (controller.signal.aborted || parentSignal.aborted || !slot.isConnected) return;
      for (const [field, kind, caption, limit] of [['brands','brand','Brand',3], ['videos','video','Watch',compact ? 1 : 2], ['articles','article','Read',2]]) {
        const section = el('section', null, 'hbr-resource-group hbr-resource-group--' + kind);
        section.append(el('h3', caption)); let count = 0;
        const items = (Array.isArray(data[field]) ? data[field] : [])
          .filter(item => item && item.documentType === kind && resourceUrl(item.url)).slice(0, limit);
        const chapterLimit = compact ? 1 : items.length > 1 ? 2 : 3;
        for (const item of items) {
          const card = resourceCard(item, kind, compact, count, chapterLimit); if (card) { section.append(card); count++; }
        }
        if (kind === 'brand' && count === 1) section.classList.add('hbr-resource-group--featured');
        if (count) slot.append(section);
      }
      if (slot.childElementCount) {
        slot.dataset.resourceGroups = String(slot.childElementCount);
        slot.hidden = false;
        if (compact) container.querySelector('.hbr-suggestion-layout').classList.add('hbr-suggestion-layout--resources');
      }
    } catch (_) { /* Product results remain fully usable if optional content fails. */ }
    finally { clearTimeout(timer); parentSignal.removeEventListener('abort', abort); if (slot.hidden) slot.remove(); }
  }

  async function suggestions(form) {
    const input = form.querySelector('input[name=q]'), box = form.querySelector('[data-hbr-suggestions]');
    suggestionAbort?.abort(); suggestionAbort = new AbortController();
    const controller = suggestionAbort;
    if (input.value.trim().length < 2) { box.hidden = true; return; }
    const version = generation, query = input.value.trim();
    try {
      if (!groupsReady) await ensureGroups();
      if (controller.signal.aborted || controller !== suggestionAbort || version !== generation || input.value.trim() !== query) return;
      const key = '/v1/suggestions?' + searchParameters(query);
      const cached = suggestionResponses.get(key);
      const data = cached && Date.now() - cached.savedAt < 20000 ? cached.data
        : await request(key, { signal: suggestionAbort.signal });
      if (controller.signal.aborted || controller !== suggestionAbort || version !== generation || input.value.trim() !== query) return;
      suggestionResponses.delete(key);
      suggestionResponses.set(key, { data, savedAt: cached && data === cached.data ? cached.savedAt : Date.now() });
      if (suggestionResponses.size > 20) suggestionResponses.delete(suggestionResponses.keys().next().value);
      const layout = el('div', null, 'hbr-suggestion-layout');
      const products = el('section', null, 'hbr-suggestion-products'); products.setAttribute('aria-label', 'Product previews');
      products.append(el('h3', 'Parts', 'hbr-suggestion-heading'));
      if (!data.total) products.append(el('p', state.selectedGroupIds.length ? 'No matching parts for this vehicle selection.' : 'No matching parts. Try another name or part number.', 'hbr-suggestion-status'));
      // Cap the combined list, even if an older API returns several product sections.
      data.sections.flatMap(section => section.products).slice(0, 3).forEach(p => products.append(card(p, true)));
      layout.append(products);
      const footer = el('div', null, 'hbr-suggestion-footer');
      footer.append(searchResultsLink('See all results', searchPath(root, state, query), 'hbr-button'),
        searchResultsLink('Search all parts', searchPath(root, { ...state, selectedGroupIds: [] }, query, { groups: '' }), 'hbr-text-link'));
      box.replaceChildren(el('p', selectedLabel(), 'hbr-suggestion-context'), layout, footer);
      box.scrollTop = 0;
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
      loadSearchResources(box, query, controller.signal, true);
      // Only three previews: reuse the same bounded, cached Shopify pricing jobs.
      // Keep the result-grid observer intact while the dropdown is open.
      box.querySelectorAll('[data-hbr-sale-handle]').forEach(checkCardSale);
    } catch (error) {
      if (controller.signal.aborted || controller !== suggestionAbort || version !== generation || input.value.trim() !== query) return;
      box.dataset.errorCode = requestErrorCode(error);
      box.replaceChildren(el('p', 'Search preview is temporarily unavailable. Try again or open the full search.', 'hbr-suggestion-status'),
        button('Retry preview', e => { e.stopPropagation(); queueSuggestions(form); }), searchResultsLink('View search results', searchDestination(query), 'hbr-text-link'));
      box.hidden = false; input.setAttribute('aria-expanded', 'true');
    } finally { if (controller === suggestionAbort) box.removeAttribute('aria-busy'); scheduleActivity(); }
  }
  function nativeResults(show) {
    document.querySelectorAll('[data-hbr-native-search]').forEach(n => { n.hidden = !show; });
    document.documentElement.removeAttribute('data-hbr-search-pending');
  }
  function setQueryValues(params, values) {
    Object.entries(values).forEach(([key, value]) => {
      params.delete(key);
      for (const item of Array.isArray(value) ? value : [value]) if (item !== '' && item != null) params.append(key, item);
    });
  }
  const subCategoryValues = params => [...new Set(params.getAll('subCategory').filter(Boolean))];
  function updateSearchFilters(values) {
    const url = new URL(location.href);
    setQueryValues(url.searchParams, values);
    url.searchParams.delete('hbr_page'); history.pushState({}, '', url); refreshResults();
  }
  function filterGroup(key, caption) {
    const details = el('details', null, 'hbr-filter-group'); details.dataset.filterGroup = key;
    details.open = filterSections.has(key) ? filterSections.get(key) : key !== 'subCategory' || new URL(location.href).searchParams.has(key);
    details.append(el('summary', caption));
    details.addEventListener('toggle', () => { if (details.isConnected) filterSections.set(key, details.open); });
    return details;
  }
  function openFilters() {
    if (!filterDialog) {
      filterDialog = el('dialog', null, 'hbr-filter-dialog'); filterDialog.setAttribute('aria-labelledby', 'hbr-filter-title');
      const head = el('div', null, 'hbr-filter-dialog-head'), title = el('h2', 'Filters'); title.id = 'hbr-filter-title';
      head.append(title, button('Close', () => filterDialog.close(), 'hbr-filter-close'));
      const body = el('div', null, 'hbr-filter-dialog-body');
      const foot = el('div', null, 'hbr-filter-dialog-foot');
      foot.append(button('Show results →', () => filterDialog.close(), 'hbr-button hbr-button--primary'));
      filterDialog.append(head, body, foot); document.body.append(filterDialog);
      filterDialog.addEventListener('close', () => {
        if (currentFilters && currentSidebar) currentSidebar.append(currentFilters);
        document.documentElement.classList.remove('hbr-filters-open');
        document.querySelector('[data-hbr-open-filters]')?.focus();
      });
    }
    filterDialog.querySelector('.hbr-filter-dialog-body').replaceChildren(currentFilters);
    filterDialog.showModal(); document.documentElement.classList.add('hbr-filters-open');
    filterDialog.querySelector('button').focus();
  }
  async function refreshResults() {
    const target = document.querySelector('[data-hbr-results]'); if (!target) return;
    pendingSearchActivity = null;
    resultsAbort?.abort(); resultsAbort = new AbortController();
    const controller = resultsAbort;
    const params = new URL(location.href).searchParams, version = generation;
    const query = params.get('q') || '', category = params.get('category') || '', brand = params.get('brand') || '';
    const subCategories = subCategoryValues(params), priceMin = params.get('priceMin') || '', priceMax = params.get('priceMax') || '';
    const page = params.get('hbr_page') || '1';
    target.hidden = false; target.classList.remove('hbr-search-fallback'); delete target.dataset.errorCode;
    target.classList.toggle('hbr-discovery--browse', !query);
    target.setAttribute('aria-busy', 'true');
    const order = target.querySelector('.hbr-results-order');
    if (order) order.textContent = 'Updating results...';
    if (!target.querySelector('.hbr-search-layout, [data-hbr-initial-loading]')) target.replaceChildren(el('p', 'Loading parts for ' + selectedLabel() + '...', 'hbr-loading'));
    nativeResults(false);
    try {
      if (!groupsReady) await ensureGroups();
      if (controller.signal.aborted || controller !== resultsAbort || generation !== version) return;
      const data = await request('/v1/search?' + searchParameters(query, { category, brand, subCategory: subCategories, priceMin, priceMax, page, pageSize: 40, pagination: 'combined' }), { signal: resultsAbort.signal });
      if (controller.signal.aborted || controller !== resultsAbort || generation !== version) return;
      const focusedFilter = currentFilters?.contains(document.activeElement) && document.activeElement?.name
        ? { name: document.activeElement.name, value: document.activeElement.value } : null;
      const hero = el('header', null, 'hbr-results-head'), heading = el('div');
      const title = el('h1'); title.append(el('span', query || 'Discover parts', 'hbr-title-accent'));
      if (query) heading.append(el('p', 'Search results for:', 'hbr-eyebrow'));
      heading.append(title);
      hero.append(heading);
      const vehicleBar = el('div', null, 'hbr-results-vehicle');
      const car = el('div', null, 'hbr-results-car'); car.append(el('small', 'My garage'), el('strong', state.selectedGroupIds.length ? selectedLabel() : 'Find parts for your car'));
      car.append(el('span', state.selectedGroupIds.length ? (state.includeUniversal ? 'Includes universal parts.' : 'Check product application notes for exact fit.') : 'Choose your Honda or Acura to narrow your search.'));
      vehicleBar.append(car, button(state.selectedGroupIds.length ? 'Change vehicle' : 'Add vehicle', e => openGarage(e.currentTarget), 'hbr-vehicle-change'));
      target.replaceChildren(hero, vehicleBar);
      document.title = (query ? 'Search results for "' + query + '"' : 'Discover parts') + ' | Hybrid Racing';
      const layout = el('div', null, 'hbr-search-layout'), sidebar = el('aside', null, 'hbr-search-sidebar'); sidebar.setAttribute('aria-label', 'Product filters');
      const results = el('div', null, 'hbr-search-products'), tools = el('div', null, 'hbr-results-tools');
      const summary = el('p', null, 'hbr-results-summary'); summary.append(el('strong', String(data.total)), document.createTextNode(data.total === 1 ? ' part' : ' parts'));
      const mobileFilters = button('Filters', openFilters, 'hbr-open-filters'); mobileFilters.dataset.hbrOpenFilters = ''; mobileFilters.setAttribute('aria-haspopup', 'dialog');
      tools.append(summary, el('span', 'Most relevant first', 'hbr-results-order'), mobileFilters); results.append(tools);
      layout.append(sidebar, results); target.append(layout);
      const supported = new Set(data.supportedFilters || ['category', 'brand']);
      if (subCategories.length > 1 && !supported.has('multiSubCategory')) throw new Error('Search does not support multiple subcategories yet.');
      if ((!supported.has('subCategory') && subCategories.length) || (!supported.has('price') && (priceMin || priceMax)))
        results.append(el('p', 'Subcategory or price filters in this link are not available for this search and have not been applied. Use Clear filters to remove them.', 'hbr-notice'));
      const controls = el('div', null, 'hbr-sidebar-filters');
      const clearFilters = () => updateSearchFilters({category:'', subCategory:'', brand:'', priceMin:'', priceMax:''});
      const filterTitle = el('div', null, 'hbr-filter-heading'); filterTitle.append(el('h2', 'Filters'), button('Clear filters', clearFilters, 'hbr-filter-clear')); controls.append(filterTitle);
      const chips = el('div', null, 'hbr-filter-chips'); chips.setAttribute('aria-label', 'Active filters');
      for (const [key, caption] of [['category','Category'], ['subCategory','Subcategory'], ['brand','Brand'], ['priceMin','Min. price'], ['priceMax','Max. price']]) {
        for (const value of key === 'subCategory' ? subCategories : [params.get(key)].filter(Boolean)) {
          const chip = button(caption + ': ' + value, () => updateSearchFilters(key === 'subCategory'
            ? {subCategory: subCategoryValues(new URL(location.href).searchParams).filter(v => v !== value)}
            : key === 'category' ? {category:'', subCategory:[]} : {[key]:''}), 'hbr-filter-chip');
          chip.setAttribute('aria-label', 'Remove ' + caption.toLowerCase() + ' filter: ' + value); chips.append(chip);
        }
      }
      results.append(chips);
      function choicesFor(key, active = []) {
        const values = data.facets[key] || {}, choices = Object.entries(values).sort(([a], [b]) => a.localeCompare(b));
        active.filter(v => v && !Object.hasOwn(values, v)).forEach(v => choices.push([v, 0]));
        return choices;
      }
      function option(key, value, caption, count, checked, onChange, type = 'radio') {
        const label = el('label', null, 'hbr-filter-option'), input = el('input');
        input.type = type; input.name = key; input.value = value; input.checked = checked;
        input.disabled = count === 0 && !checked;
        input.addEventListener('change', () => onChange(input));
        label.append(input, el('span', caption));
        if (count !== null) label.append(el('small', String(count)));
        return label;
      }
      if (supported.has('category')) {
        const group = filterGroup('category', 'Category'), tree = el('div', null, 'hbr-category-tree');
        tree.setAttribute('role', 'group'); tree.setAttribute('aria-label', 'Category');
        tree.append(option('category', '', 'All categories', null, !category, () => updateSearchFilters({category:'', subCategory:[]})));
        for (const [value, count] of choicesFor('category', [category])) {
          const active = value === category, branch = el('div', null, 'hbr-category-branch'), row = el('div', null, 'hbr-category-row');
          const children = el('div', null, 'hbr-subcategory-tree'); children.setAttribute('role', 'group'); children.setAttribute('aria-label', value + ' subcategories');
          const sectionKey = 'category:' + value;
          children.hidden = !active || filterSections.get(sectionKey) === false;
          const selectCategory = () => { filterSections.set(sectionKey, true); updateSearchFilters({category:value, subCategory:[]}); };
          const parent = option('category', value, value, count, active, selectCategory);
          const toggle = button('', () => {
            if (!active) { selectCategory(); return; }
            children.hidden = !children.hidden; filterSections.set(sectionKey, !children.hidden);
            toggle.setAttribute('aria-expanded', String(!children.hidden));
          }, 'hbr-category-toggle');
          toggle.name = 'categoryToggle'; toggle.value = value;
          toggle.setAttribute('aria-label', value + ' subcategories'); toggle.setAttribute('aria-expanded', String(!children.hidden));
          parent.addEventListener('click', () => { if (active) { children.hidden = false; filterSections.set(sectionKey, true); toggle.setAttribute('aria-expanded', 'true'); } });
          row.append(parent); if (supported.has('subCategory')) row.append(toggle);
          branch.append(row);
          if (active && supported.has('subCategory')) {
            const multi = supported.has('multiSubCategory');
            for (const [sub, subCount] of choicesFor('subCategory', subCategories)) {
              const child = option('subCategory', sub, sub, subCount, subCategories.includes(sub), input => {
                const current = new URL(location.href).searchParams;
                if (current.get('category') !== value) return;
                const next = subCategoryValues(current).filter(v => v !== sub);
                if (input.checked) next.push(sub);
                if (next.length > 20) { input.checked = false; return; }
                updateSearchFilters({subCategory: multi ? next : input.checked ? [sub] : []});
              }, multi ? 'checkbox' : 'radio');
              if (multi && subCategories.length >= 20 && !subCategories.includes(sub)) child.querySelector('input').disabled = true;
              children.append(child);
            }
            if (!children.querySelector('input')) children.append(el('p', 'No subcategories for these results.', 'hbr-filter-hint'));
            branch.append(children);
          }
          tree.append(branch);
        }
        group.append(tree); controls.append(group);
      }
      // Older shared links may contain a subcategory without a parent. Preserve it
      // and its removable chip; choosing a category starts a new branch selection.
      for (const [key, caption] of [['brand', 'Brand']]) {
        if (!supported.has(key)) continue;
        const group = filterGroup(key, caption), list = el('div', null, 'hbr-filter-options'); list.setAttribute('role', 'group'); list.setAttribute('aria-label', caption);
        const active = params.get(key) || '';
        const choices = choicesFor(key, [active]);
        choices.unshift(['', null]);
        for (const [value, count] of choices) {
          list.append(option(key, value, value || 'All', count, active === value, input => { if (input.checked) updateSearchFilters({[key]:value}); }));
        }
        group.append(list); controls.append(group);
      }
      if (supported.has('price')) {
        const priceForm = el('form', null, 'hbr-price-filter'), fields = el('fieldset');
        fields.append(el('legend', 'Price (USD)'));
        const inputs = {};
        for (const [key, caption] of [['priceMin', 'Minimum'], ['priceMax', 'Maximum']]) {
          const label = el('label', caption + ' '), input = el('input');
          input.type = 'number'; input.name = key; input.min = '0'; input.max = '1000000'; input.step = 'any'; input.placeholder = 'Any';
          input.value = params.get(key) || ''; inputs[key] = input; label.append(input); fields.append(label);
        }
        const validate = () => inputs.priceMax.setCustomValidity(inputs.priceMin.value && inputs.priceMax.value && Number(inputs.priceMin.value) > Number(inputs.priceMax.value)
          ? 'Maximum price must be at least the minimum price.' : '');
        priceForm.addEventListener('input', validate);
        const apply = el('button', 'Apply price', 'hbr-button hbr-button--quiet'); apply.type = 'submit'; fields.append(apply);
        priceForm.append(fields);
        priceForm.addEventListener('submit', e => {
          e.preventDefault(); validate(); if (!priceForm.reportValidity()) return;
          const u = new URL(location.href);
          Object.entries(inputs).forEach(([key, input]) => input.value === '' ? u.searchParams.delete(key) : u.searchParams.set(key, input.value));
          u.searchParams.delete('hbr_page'); history.pushState({}, '', u); refreshResults();
        });
        const priceGroup = filterGroup('price', 'Price (USD)'); priceGroup.append(priceForm); controls.append(priceGroup);
      }
      currentFilters = controls; currentSidebar = sidebar;
      if (filterDialog?.open) {
        filterDialog.querySelector('.hbr-filter-dialog-body').replaceChildren(controls);
        const focus = focusedFilter && [...controls.querySelectorAll('input,button[name]')].find(n => n.name === focusedFilter.name && n.value === focusedFilter.value);
        (focus || filterDialog.querySelector('button')).focus();
      } else {
        sidebar.append(controls);
        if (focusedFilter) [...controls.querySelectorAll('input,button[name]')].find(n => n.name === focusedFilter.name && n.value === focusedFilter.value)?.focus();
      }
      if (!data.total) {
        const empty = el('div', null, 'hbr-search-empty');
        empty.append(el('h2', 'No parts found'), el('p', 'Try another search or clear a filter. You can also include universal parts.'),
          button('Clear filters', clearFilters), link('Search all parts', searchPath(root, { ...state, selectedGroupIds: [] }, query, { groups: '' }), 'hbr-text-link')); results.append(empty);
      }
      const products = data.sections.flatMap(section => section.products);
      if (products.length) {
        const band = el('section', null, 'hbr-result-band'); band.setAttribute('aria-label', 'Parts');
        const grid = el('div', null, 'hbr-results-grid'); products.forEach(p => grid.append(card(p))); band.append(grid); results.append(band);
      }
      if (Number(page) === 1) loadSearchResources(results, query, controller.signal, false);
      watchSaleBadges(target);
      const pages = Math.max(1, data.totalPages ?? Math.max(...data.sections.map(s => s.totalPages)));
      const nav = el('nav', null, 'hbr-paging'); nav.setAttribute('aria-label', 'Vehicle search pages');
      const current = Number(page);
      const move = next => { const u = new URL(location.href); u.searchParams.set('hbr_page', next); history.pushState({}, '', u); refreshResults(); target.scrollIntoView({ block: 'start' }); };
      if (current > 1) nav.append(button('Previous', () => move(current - 1)));
      nav.append(el('span', 'Page ' + current + ' of ' + pages)); if (current < pages) nav.append(button('Next', () => move(current + 1))); results.append(nav);
      const trackKey = JSON.stringify([query, state.selectedGroupIds]);
      if (trackKey !== lastTrackedSearch && query.trim()) {
        // Keep only the currently displayed search in memory while account/consent
        // startup finishes. Search rendering never waits for analytics.
        pendingSearchActivity = { key: trackKey, query, resultCount: data.total, groupIds: [...state.selectedGroupIds] };
        trackPendingSearch();
      }
    } catch (error) {
      if (generation !== version || controller !== resultsAbort || controller.signal.aborted) return;
      target.dataset.errorCode = requestErrorCode(error);
      target.classList.add('hbr-search-fallback');
      if (filterDialog?.open) filterDialog.close();
      const notice = el('div', null, 'hbr-notice');
      const currentNativeResults = query === nativeSearchQuery;
      notice.append(el('p', currentNativeResults
        ? 'Vehicle filtering is unavailable. The regular Shopify results below are not filtered for your car.'
        : 'Search is temporarily unavailable. Try again or reload the search.'), button('Retry vehicle search', refreshResults));
      if (!currentNativeResults) notice.append(link('Reload search', location.href, 'hbr-text-link'));
      target.replaceChildren(notice); watchSaleBadges(target); nativeResults(currentNativeResults);
    } finally { if (controller === resultsAbort) target.removeAttribute('aria-busy'); }
  }
  async function refreshFit() {
    const blocks = [...document.querySelectorAll('[data-hbr-fit-check]')]; if (!blocks.length) return;
    fitAbort?.abort(); fitAbort = new AbortController();
    const controller = fitAbort;
    const version = generation;
    blocks.forEach(b => {
      b.replaceChildren(el('h3', 'Vehicle compatibility', 'hbr-fit-heading'));
      if (!state.selectedGroupIds.length) b.append(button('Choose your vehicle', e => openGarage(e.currentTarget), 'hbr-fit-change'));
      else b.append(el('p', 'Checking compatibility...', 'hbr-fit-message'));
    });
    if (!state.selectedGroupIds.length) return;
    try {
      const data = await request('/v1/fitment/check', { method: 'POST', signal: fitAbort.signal,
        body: JSON.stringify({ handles: [...new Set(blocks.map(b => b.dataset.handle))].slice(0, 24), groupIds: state.selectedGroupIds }) });
      if (generation !== version || controller !== fitAbort || controller.signal.aborted) return;
      blocks.forEach(block => {
        block.replaceChildren(el('h3', 'Vehicle compatibility', 'hbr-fit-heading'));
        const product = data.products.find(p => p.handle === block.dataset.handle);
        const fits = product?.fits?.length ? product.fits : state.selectedGroupIds.map(groupId => ({groupId, status:'not-confirmed', reason:'Review this product\'s application notes before ordering.'}));
        fits.forEach(fit => {
          const row = el('div', null, 'hbr-check-row'), vehicle = el('div', null, 'hbr-fit-vehicle');
          const change = button('Change', e => openGarage(e.currentTarget), 'hbr-fit-change');
          change.setAttribute('aria-label', 'Change vehicle: ' + groupLabel(fit.groupId));
          vehicle.append(el('strong', groupLabel(fit.groupId)), change); row.append(vehicle);
          const listed = fit.status === 'group-listed', universal = fit.status === 'universal';
          const status = el('p', null, 'hbr-fit-status' + (listed ? ' hbr-fit-status--listed' : ''));
          if (listed) {
            const icon = el('span', '✓', 'hbr-check-icon'); icon.setAttribute('aria-hidden', 'true'); status.append(icon);
          }
          status.append(el('span', listed ? 'Fits your vehicle group' : universal ? 'Universal' : 'Fitment is not confirmed'));
          row.append(status, el('small', fit.reason, 'hbr-fit-disclaimer'));
          block.append(row);
        });
      });
    } catch (_) {
      if (generation !== version || controller !== fitAbort || controller.signal.aborted) return;
      blocks.forEach(b => b.replaceChildren(el('h3', 'Vehicle compatibility', 'hbr-fit-heading'), el('p', 'Check unavailable. Review the application notes before ordering.', 'hbr-fit-message'), button('Retry', refreshFit, 'hbr-fit-change')));
    }
  }
  function collectionArray(value) {
    try { const parsed = JSON.parse(value || '[]'); return Array.isArray(parsed) ? parsed : []; } catch (_) { return []; }
  }
  function discoveryVehicleFilter(panel) {
    const labels = state.selectedGroupIds.map(groupLabel);
    const canFilter = panel.dataset.filterSupported === 'true' && (labels.length <= 1 || panel.dataset.operator === 'OR');
    const universal = collectionArray(panel.dataset.filterValues).find(value => /^universal$/i.test(value));
    if (canFilter && labels.length && state.includeUniversal && universal && panel.dataset.operator === 'OR') labels.push(universal);
    return { labels, canFilter };
  }
  function discoveryCollectionUrl(href, panel, clear = false) {
    const url = new URL(href, location.href), current = new URL(location.href);
    if (url.origin !== current.origin || url.pathname !== current.pathname) return null;
    if (clear) for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    for (const key of ['preview_theme_id', 'groups', 'universal']) {
      if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    url.searchParams.delete('section_id');
    // Keep the assigned/previewed template so Shopify renders the same section ID.
    // Forcing the discovery preview here would discard custom collection content.
    if (panel.dataset.templateView) url.searchParams.set('view', panel.dataset.templateView);
    else url.searchParams.delete('view');
    if (!groupsReady && !url.searchParams.has('filter.p.m.pim.vehicle_fitment')) {
      current.searchParams.getAll('filter.p.m.pim.vehicle_fitment').forEach(label => url.searchParams.append('filter.p.m.pim.vehicle_fitment', label));
    }
    if (groupsReady) {
      const { labels, canFilter } = discoveryVehicleFilter(panel);
      if (canFilter || !state.selectedGroupIds.length) {
        url.searchParams.delete('filter.p.m.pim.vehicle_fitment');
        labels.forEach(label => url.searchParams.append('filter.p.m.pim.vehicle_fitment', label));
      }
      url.searchParams.set('groups', state.selectedGroupIds.join(','));
      url.searchParams.set('universal', String(state.includeUniversal));
    }
    return url;
  }
  function initDiscoveryCollection(panel = document.querySelector('[data-hbr-discovery-collection]')) {
    if (!panel || panel.dataset.initialized) return;
    panel.dataset.initialized = 'true';
    const previousFocus = document.activeElement;
    const form = panel.querySelector('[data-hbr-collection-filters]');
    currentFilters = form; currentSidebar = panel.querySelector('.hbr-search-sidebar');
    form.querySelectorAll('[data-filter-group]').forEach(details => {
      const key = details.dataset.filterGroup;
      if (filterSections.has(key)) details.open = filterSections.get(key);
      details.addEventListener('toggle', () => { if (details.isConnected) filterSections.set(key, details.open); });
    });
    const submit = () => {
      if (!form.reportValidity()) return;
      const url = discoveryCollectionUrl(location.href, panel); if (!url) return;
      for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') && key !== 'filter.p.m.pim.vehicle_fitment') url.searchParams.delete(key);
      for (const [key, value] of new FormData(form)) {
        if (!value || key === 'view' || key === 'filter.p.m.pim.vehicle_fitment') continue;
        if (key === 'sort_by') url.searchParams.set(key, value); else url.searchParams.append(key, value);
      }
      url.searchParams.delete('page'); refreshCollection(url.href, panel);
    };
    form.addEventListener('submit', event => { event.preventDefault(); submit(); });
    form.addEventListener('change', event => { if (event.target.type === 'checkbox') submit(); });
    panel.querySelector('[data-hbr-collection-sort]').addEventListener('change', submit);
    const bindLinks = container => container.querySelectorAll('[data-hbr-collection-link], [data-hbr-clear-collection]').forEach(anchor => {
      const clear = anchor.hasAttribute('data-hbr-clear-collection');
      const url = discoveryCollectionUrl(anchor.href, panel, clear); if (url) anchor.href = url.href;
      anchor.addEventListener('click', event => {
        if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const next = discoveryCollectionUrl(anchor.href, panel, clear); if (!next) return;
        event.preventDefault(); refreshCollection(next.href, panel, false, anchor.closest('.hbr-paging') !== null);
      });
    });
    bindLinks(panel);
    panel.querySelector('[data-hbr-open-filters]').addEventListener('click', openFilters);
    if (filterDialog?.open) {
      filterDialog.querySelector('.hbr-filter-dialog-body').replaceChildren(form);
      const focus = [...form.elements].find(node => node.name === previousFocus?.name && node.value === previousFocus?.value);
      (focus || filterDialog.querySelector('button')).focus({ preventScroll: true });
    }
  }
  function updateDiscoveryCollectionContext(panel, apply) {
    initDiscoveryCollection(panel);
    if (!groupsReady) return;
    const { labels, canFilter } = discoveryVehicleFilter(panel);
    const current = collectionArray(panel.dataset.activeFitment);
    const applied = labels.length === current.length && labels.every(label => current.includes(label));
    const text = panel.querySelector('[data-hbr-collection-status]'), action = panel.querySelector('[data-hbr-apply-collection]');
    const vehicle = panel.querySelector('[data-hbr-collection-vehicle]');
    if (vehicle) vehicle.textContent = state.selectedGroupIds.length ? selectedLabel() : 'Shop for your car';
    if (text) text.textContent = !applied ? 'These results have not been filtered for your selection yet.'
      : !state.selectedGroupIds.length ? 'Choose your Honda or Acura to narrow this collection.'
      : labels.some(label => /^universal$/i.test(label)) ? 'Includes universal parts.' : 'Parts listed for your selected vehicle' + (state.selectedGroupIds.length > 1 ? 's.' : '.');
    if (action) {
      action.hidden = applied || !canFilter;
      const url = discoveryCollectionUrl(location.href, panel); url.searchParams.delete('page'); action.href = url.href;
      action.onclick = event => { event.preventDefault(); refreshCollection(action.href, panel); };
    }
    const error = panel.querySelector('[data-hbr-collection-error]');
    if (!canFilter && state.selectedGroupIds.length) {
      error.hidden = false; error.textContent = 'Vehicle filtering is unavailable for this collection. The products below use the current collection filters.';
    }
    panel.querySelectorAll('[data-hbr-collection-card]').forEach(card => {
      const target = card.querySelector('[data-hbr-card-fit]'), tagged = collectionArray(card.dataset.fitmentLabels);
      target.replaceChildren();
      if (card.dataset.universal === 'true') target.append(fitBadge({ status: 'universal' }));
      else state.selectedGroupIds.filter(id => tagged.includes(groupLabel(id))).forEach(groupId => target.append(fitBadge({ status: 'group-listed', groupId })));
    });
    if (apply && !applied && canFilter) refreshCollection(action.href, panel);
  }
  function updateCollectionContext(apply = false) {
    const panel = document.querySelector('[data-hbr-collection]'); if (!panel) return;
    if (panel.hasAttribute('data-hbr-discovery-collection')) return updateDiscoveryCollectionContext(panel, apply);
    const text = panel.querySelector('[data-hbr-collection-status]'), action = panel.querySelector('[data-hbr-apply-collection]');
    const selected = state.selectedGroupIds.map(groupLabel), current = new URL(location.href).searchParams.getAll('filter.p.m.pim.vehicle_fitment');
    let allowed; try { allowed = JSON.parse(panel.dataset.filterValues || '[]'); } catch (_) { allowed = []; }
    if (!Array.isArray(allowed)) allowed = [];
    const universal = allowed.find(v => /^universal$/i.test(v));
    const canFilter = panel.dataset.filterSupported === 'true' && (state.selectedGroupIds.length <= 1 || panel.dataset.operator === 'OR');
    // Search can include tagged universal products; native collections filter only the selected groups.
    const applied = selected.length === current.length && selected.every(label => current.includes(label));
    text.textContent = !selected.length && applied ? 'Browsing all parts in this collection.' : applied ? 'Filtering this collection for ' + selected.join(' or ') : 'These collection results have not been filtered for your selection yet.';
    action.hidden = applied; action.textContent = canFilter ? 'Apply vehicle filter' : 'Search parts for my vehicle';
    action.href = canFilter ? collectionPath(location.href, location.origin, selected, false, universal, state.selectedGroupIds) : searchPath(root, state);
    action.onclick = canFilter ? e => { e.preventDefault(); refreshCollection(action.href, panel); } : null;
    if (apply && !applied && canFilter) refreshCollection(action.href, panel);
  }
  async function refreshCollection(href, panel, replaceHistory = false, scrollToResults = false) {
    collectionAbort?.abort(); collectionAbort = new AbortController();
    const controller = collectionAbort, version = generation;
    const wrapper = document.getElementById('shopify-section-' + panel.dataset.sectionId);
    if (!wrapper) return;
    const url = new URL(href, location.origin), visibleUrl = url.pathname + url.search;
    url.searchParams.set('section_id', panel.dataset.sectionId);
    const statusNode = panel.querySelector('[data-hbr-collection-status]');
    if (statusNode) statusNode.textContent = 'Updating this collection for your selection...';
    const errorNode = panel.querySelector('[data-hbr-collection-error]');
    if (errorNode) { errorNode.hidden = true; errorNode.replaceChildren(); }
    const timer = setTimeout(() => controller.abort(), 4000);
    wrapper.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Collection unavailable');
      const html = await response.text();
      if (generation !== version || controller !== collectionAbort || controller.signal.aborted) return;
      const documentCopy = new DOMParser().parseFromString(html, 'text/html');
      const next = documentCopy.getElementById(wrapper.id);
      if (!next || !next.querySelector('[data-hbr-collection]')) throw new Error('Incomplete section');
      // DOMParser parses with scripting disabled. Its noscript children would become
      // active fallback styles/controls when inserted into this scripted document.
      next.querySelectorAll('noscript').forEach(node => node.remove());
      const focus = document.activeElement;
      wrapper.replaceWith(next);
      if (!replaceHistory) history.pushState({}, '', visibleUrl);
      next.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: panel.dataset.sectionId } }));
      updateCollectionContext(); updateNavigationLinks();
      if (focus && !focus.isConnected && !filterDialog?.open) {
        const replacement = [...next.querySelectorAll('input, select')].find(node => node.name === focus.name && (node.tagName === 'SELECT' || node.value === focus.value));
        replacement?.focus({ preventScroll: true });
      }
      if (scrollToResults) next.querySelector('.hbr-results-tools')?.scrollIntoView({ block: 'start' });
    } catch (_) {
      if (controller !== collectionAbort || version !== generation) return;
      if (errorNode) {
        errorNode.hidden = false;
        errorNode.replaceChildren(el('span', 'Update failed. The products below still use the previous filters. '), button('Retry', () => refreshCollection(href, panel, replaceHistory, scrollToResults)));
        if (statusNode) statusNode.textContent = 'Collection update failed. Use Retry below to apply your selection.';
      } else {
        panel.querySelector('[data-hbr-collection-status]').textContent = 'Collection update failed. The results below still use the previous filters. Retry or open vehicle search.';
        const action = panel.querySelector('[data-hbr-apply-collection]'); action.hidden = false;
      }
    } finally { clearTimeout(timer); wrapper.removeAttribute('aria-busy'); }
  }
  function filterCollection(query) {
    const panel = document.querySelector('[data-hbr-collection]');
    if (!panel || !groupsReady) return false;
    const url = new URL(location.href);
    url.search = new URLSearchParams(query).toString();
    if (panel.dataset.filterSupported === 'true') {
      const labels = url.searchParams.getAll('filter.p.m.pim.vehicle_fitment');
      const selected = groups.filter(g => labels.includes(g.label)).map(g => g.id).slice(0, 5);
      url.searchParams.delete('filter.p.m.pim.vehicle_fitment');
      selected.forEach(id => url.searchParams.append('filter.p.m.pim.vehicle_fitment', groupLabel(id)));
      if (JSON.stringify(selected) !== JSON.stringify(state.selectedGroupIds)) {
        state.selectedGroupIds = selected; dirty = true; generation++;
        renderState(); fillMakes(); persist();
      }
    }
    url.searchParams.set('groups', state.selectedGroupIds.join(','));
    url.searchParams.set('universal', String(state.includeUniversal));
    return refreshCollection(url.href, panel);
  }
  async function refreshCounts() {
    const target = $('[data-hbr-categories]');
    if (!dialog.open || !target) return;
    if (!state.selectedGroupIds.length) { target.replaceChildren(); countsKey = ''; return; }
    const key = JSON.stringify([state.selectedGroupIds, state.includeUniversal]);
    if (key === countsKey) return;
    countsAbort?.abort(); countsAbort = new AbortController(); const version = generation;
    const controller = countsAbort; target.replaceChildren(el('p', 'Loading categories...', 'hbr-muted'));
    try {
      const data = await request('/v1/navigation/counts?' + searchParameters(''), { signal: countsAbort.signal });
      if (generation !== version || controller !== countsAbort || controller.signal.aborted) return;
      countsKey = key; target.replaceChildren(el('h3', 'Explore categories for your selection'));
      Object.entries(data.facets.category || {}).sort(([a], [b]) => a.localeCompare(b)).forEach(([category, count]) =>
        target.append(link(category + ' (' + count + ')', searchPath(root, state, '', { category }), 'hbr-category-link')));
      if (state.selectedGroupIds.length === 1) {
        const group = groups.find(g => g.id === state.selectedGroupIds[0]);
        if (group?.collectionHandle) target.append(link('Explore ' + group.label, root + 'collections/' + encodeURIComponent(group.collectionHandle), 'hbr-text-link'));
      }
    } catch (_) { if (controller === countsAbort) target.replaceChildren(el('p', 'Category counts unavailable. You can still search parts.', 'hbr-muted')); }
  }
  function activityStatus(value) { config.dataset.hbrActivityStatus = value; }
  function activityAllowed() { return !activityConsentRequired || privacy('analytics'); }
  function trackPendingSearch() {
    if (!pendingSearchActivity) return;
    if (!signedIn) { activityStatus('signed-out'); pendingSearchActivity = null; return; }
    // Wait for the authenticated account policy before applying the consent gate.
    if (!ready || !csrf) { activityStatus('waiting-for-account'); return; }
    if (activityConsentRequired && privacyChoice('analytics') === false) {
      activityStatus('consent-denied'); pendingSearchActivity = null; return;
    }
    const { key, ...payload } = pendingSearchActivity;
    if (!track('search-submitted', payload)) return;
    lastTrackedSearch = key; pendingSearchActivity = null;
  }
  function track(kind, extra = {}) {
    if (!signedIn) { activityStatus('signed-out'); return false; }
    if (!ready || !csrf) { activityStatus('waiting-for-account'); return false; }
    if (!activityAllowed()) { activityStatus(privacyChoice('analytics') === false ? 'consent-denied' : 'waiting-for-consent'); return false; }
    activityQueue.push({ requestId: crypto.randomUUID(), kind, groupIds: [...state.selectedGroupIds], analyticsConsent: privacy('analytics'), ...extra });
    if (activityQueue.length > 10) activityQueue.shift();
    activityStatus('queued');
    scheduleActivity();
    return true;
  }
  function pauseActivity() {
    clearTimeout(activityTimer); activityTimer = null;
    if (activityIdle != null) global.cancelIdleCallback?.(activityIdle);
    activityIdle = null; activityAbort?.abort();
  }
  function scheduleActivity() {
    if (!activityQueue.length || activityTimer || activityIdle != null || activityAbort) return;
    activityTimer = setTimeout(() => {
      activityTimer = null;
      if (global.requestIdleCallback) activityIdle = global.requestIdleCallback(() => { activityIdle = null; flushActivity(); });
      else flushActivity();
    }, 1500);
  }
  async function flushActivity() {
    if (!signedIn || !ready || !csrf || !activityAllowed() || document.visibilityState === 'hidden') {
      activityQueue.length = 0;
      activityStatus(!signedIn ? 'signed-out' : !activityAllowed() ? 'consent-unavailable' : !ready || !csrf ? 'account-unavailable' : 'page-hidden');
      return;
    }
    if (document.readyState !== 'complete' || activeRequests || saving || accountLoading || activeSaleChecks
      || document.querySelector('[data-hbr-suggestions][aria-busy="true"],[data-hbr-results][aria-busy="true"]')) { activityStatus('waiting-for-idle'); scheduleActivity(); return; }
    const payload = activityQueue.shift(); if (!payload) return;
    payload.analyticsConsent = privacy('analytics');
    const controller = new AbortController(); activityAbort = controller;
    let timedOut = false;
    const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 1000);
    try {
      // Best effort only: no CSRF refresh, retry, keepalive, or navigation-blocking beacon.
      activityStatus('sending');
      const response = await fetch(proxy + '/events', { method:'POST', credentials:'same-origin', priority:'low', signal:controller.signal,
        headers:{'Content-Type':'application/json'}, body:JSON.stringify({csrfToken:csrf,payload}) });
      // Accepted means only an HTTP success: the API may still skip a busy write.
      activityStatus(response.ok ? 'accepted' : 'http-' + response.status);
    } catch (_) { activityStatus(timedOut ? 'timed-out' : controller.signal.aborted ? 'cancelled' : 'failed'); }
    finally { clearTimeout(timer); activityAbort = null; scheduleActivity(); }
  }
  global.addEventListener('pagehide', () => { pendingSearchActivity = null; activityQueue.length = 0; pauseActivity(); });
  document.addEventListener('click', e => {
    if (videoDialog?.open || e.target.closest('.hbr-video-dialog')) return;
    const searchLink = e.target.closest('[data-hbr-search-destination]');
    if (searchLink && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && updateSearchPage(searchLink.href)) {
      e.preventDefault(); return;
    }
    const toggle = e.target.closest('[data-hbr-switcher-toggle]');
    if (toggle) { e.preventDefault(); toggleQuickSwitcher(); return; }
    if (!e.target.closest('[data-hbr-switcher]')) closeQuickSwitcher();
    const trigger = e.target.closest('[data-hbr-open]'); if (trigger) { e.preventDefault(); openGarage(trigger); }
    if (!e.target.closest('[data-hbr-search]')) hideSuggestions();
  });
  document.addEventListener('keydown', e => {
    if (!quickSwitcher || quickSwitcher.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); closeQuickSwitcher(true); }
    else if (quickSwitcher.contains(e.target) && ['ArrowDown','ArrowUp','Home','End'].includes(e.key)) {
      e.preventDefault();
      const choices = [...quickSwitcher.querySelectorAll('button:not(:disabled)')], index = choices.indexOf(document.activeElement);
      const next = e.key === 'Home' ? 0 : e.key === 'End' ? choices.length - 1 : (index + (e.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length;
      choices[next]?.focus();
    }
  });
  document.addEventListener('focusin', e => { if (quickSwitcher && e.target !== quickToggle && !quickSwitcher.contains(e.target)) closeQuickSwitcher(); });
  global.addEventListener('resize', () => { closeQuickSwitcher(); positionGarage(); });
  global.addEventListener('scroll', positionGarage);
  $('[data-hbr-close]').onclick = () => dialog.close();
  $('[data-hbr-shop-link]').addEventListener('click', event => {
    if (garageStayOnPage) { event.preventDefault(); dialog.close(); }
  });
  dialog.addEventListener('close', () => returnFocus?.focus());
  $('[data-hbr-add-vehicle]').onclick = () => {
    pickerExpanded = true; garageManaging = false; pickerStep = 'make';
    $('[data-hbr-make]').value = '';
    fillSelect($('[data-hbr-model]'), [], 'Choose model'); fillSelect($('[data-hbr-group]'), [], 'Choose year range');
    $('[data-hbr-nickname]').value = ''; notify(''); updatePickerActions(); $('[data-hbr-picker-title]').focus();
  };
  $('[data-hbr-garage-back]').onclick = () => { pickerExpanded = false; renderState(); $('[data-hbr-add-vehicle]').focus(); };
  $('[data-hbr-manage]').onclick = () => { garageManaging = !garageManaging; renderState(); };
  dialog.querySelectorAll('[data-hbr-step]').forEach(n => n.addEventListener('click', () => {
    pickerStep = n.dataset.hbrStep; renderPicker(); $('[data-hbr-picker-title]').focus();
  }));
  $('[data-hbr-make]').onchange = e => {
    fillSelect($('[data-hbr-model]'), [...new Set(groups.filter(g => g.make === e.target.value).map(g => g.model))].sort().map(m => [m, m]), 'Choose model');
    fillSelect($('[data-hbr-group]'), [], 'Choose year range');
    pickerStep = 'model';
    updatePickerActions();
  };
  $('[data-hbr-model]').onchange = e => {
    fillSelect($('[data-hbr-group]'), groups.filter(g => g.make === $('[data-hbr-make]').value && g.model === e.target.value).map(g => [g.id, g.label]), 'Choose year range');
    pickerStep = 'group';
    updatePickerActions();
  };
  $('[data-hbr-group]').onchange = updatePickerActions;
  $('[data-hbr-choose]').onclick = () => {
    const id = $('[data-hbr-group]').value; if (!id) { notify('Choose a make, model, and year range.'); return; }
    changeSelection([id]); notify('Shopping selection updated.'); dialog.close();
    if (!garageStayOnPage && !document.querySelector('[data-hbr-results], [data-hbr-collection], [data-hbr-fit-check]')) location.assign(searchPath(root, state));
  };
  $('[data-hbr-save-current]').onclick = () => {
    if (signedIn && (!ready || conflict)) { notify('Connect your account before saving cars.'); return; }
    const id = $('[data-hbr-group]').value || (state.selectedGroupIds.length === 1 ? state.selectedGroupIds[0] : '');
    if (!groups.some(g => g.id === id) || state.vehicles.some(v => v.groupId === id)) return;
    if (state.vehicles.length >= 20) { notify('Your garage supports up to 20 saved cars.'); return; }
    const label = $('[data-hbr-nickname]').value.trim() || groupLabel(id);
    state.vehicles.push({ id: crypto.randomUUID(), groupId: id, label }); state.selectedGroupIds = [id];
    $('[data-hbr-nickname]').value = ''; pickerExpanded = false; garageManaging = false; changed(); renderState();
    $('[data-hbr-add-vehicle]').focus();
    if (!signedIn) notify(privacy('preferences') ? 'Car saved on this device.' : 'Car added on this page. Sign in to keep your garage.');
  };
  $('[data-hbr-browse-all]').onclick = () => { changeSelection([]); dialog.close(); };
  $('[data-hbr-universal]').onchange = e => { state.includeUniversal = e.target.checked; changed(); };
  $('[data-hbr-multiple]').onchange = e => { if (!e.target.checked && state.selectedGroupIds.length > 1) changeSelection(state.selectedGroupIds.slice(0, 1)); else renderState(); };
  $('[data-hbr-retry-save]').onclick = async () => {
    if (conflict) { notify('Another device changed your garage. Reopen this page before saving to avoid replacing those changes.'); return; }
    if (!ready) await syncAccount(); else persist();
  };
  $('[data-hbr-retry-vehicles]').onclick = () => ensureGroups().catch(() => {});
  document.querySelectorAll('[data-hbr-signin]').forEach(n => { n.hidden = signedIn; });
  document.querySelectorAll('[data-hbr-search]').forEach(form => {
    const input = form.querySelector('input[name=q]');
    form.addEventListener('submit', e => {
      e.preventDefault();
      const destination = searchDestination(input.value);
      if (!updateSearchPage(destination)) location.assign(destination);
    });
    input.addEventListener('input', () => queueSuggestions(form));
    input.addEventListener('focus', () => queueSuggestions(form));
    const suggestions = form.querySelector('[data-hbr-suggestions]');
    input.addEventListener('keydown', e => {
      if (e.key === 'Escape') hideSuggestions();
      if (e.key === 'ArrowDown' && suggestions && !suggestions.hidden) {
        const first = [...suggestions.querySelectorAll('a[href],button:not(:disabled)')].find(n => !n.closest('[hidden]'));
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    suggestions?.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        e.preventDefault(); e.stopPropagation();
        // Focus can queue suggestions; close last so Escape always dismisses it.
        input.focus(); hideSuggestions();
      }
    });
  });
  window.addEventListener('popstate', () => {
    hideSuggestions(); syncSearchInputs();
    generation++; applyUrlContext(); fillMakes(); refreshResults(); refreshFit();
    const panel = document.querySelector('[data-hbr-collection]');
    if (panel) refreshCollection(location.href, panel, true);
  });
  document.addEventListener('visitorConsentCollected', () => { loadGuest(); saveGuest(); renderState(); trackPendingSearch(); });
  document.addEventListener('hybrid:collectionrendered', updateNavigationLinks);
  global.HybridGarage = {
    open: openGarage, selectedGroups: () => [...state.selectedGroupIds], filterCollection,
    selection: () => ({ groups: state.selectedGroupIds.map(id => ({ id, label: groupLabel(id) })), includeUniversal: state.includeUniversal }),
    browseUrl: () => searchPath(root, state),
    checkProducts: (handles, groupIds, signal) => request('/v1/fitment/check', { method: 'POST', signal,
      body: JSON.stringify({ handles: [...new Set(handles)].slice(0, 24), groupIds: unique(groupIds).slice(0, 5) }) })
  };
  initDiscoveryCollection();
  loadGuest(false);
  renderState();
  ensureGroups().catch(() => {
    status('Vehicle services are unavailable. You can continue shopping.'); refreshResults(); refreshFit();
    const text = document.querySelector('[data-hbr-discovery-collection] [data-hbr-collection-status]');
    if (text) text.textContent = 'Vehicle choices are unavailable. These products use the current collection filters.';
  });
  if (signedIn) syncAccount();
  initializePreferences();
  document.addEventListener('DOMContentLoaded', initializePreferences, { once: true });
  global.addEventListener('pagehide', () => clearTimeout(consentTimer));
})(typeof window !== 'undefined' ? window : globalThis);
